<template>
  <div class="p-6">
    <div class="mb-6">
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white mb-2">
        {{ isEditing ? 'Editar Prototipo' : 'Nuevo Prototipo' }}
      </h1>
      <p class="text-gray-600 dark:text-gray-400">
        Sistema de prototipos con catálogos dinámicos
      </p>
    </div>

    <!-- Layout de 2 columnas -->
    <div class="grid grid-cols-1 ">
      <!-- Columna Principal (2/3) -->
      <div class="xl:col-span-2 space-y-6">
        <!-- Formulario básico del prototipo -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 mb-6">
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
          Información General
        </h2>
      </div>
      
      <div class="p-6 grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Contacto *
          </label>
          <div class="relative">
            <input
              :value="contactoSeleccionadoNombre"
              type="text"
              readonly
              @click="abrirModalContacto"
              class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200 cursor-pointer"
              placeholder="Seleccione un contacto"
            />
            <button
              type="button"
              @click="abrirModalContacto"
              class="absolute right-1 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded"
            >
              <svg class="w-4 h-4 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
              </svg>
            </button>
          </div>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Proyecto *
          </label>
          <input
            v-model="formData.proyecto"
            type="text"
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200"
            placeholder="Nombre del proyecto"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Fracción *
          </label>
          <div class="relative">
            <input
              :value="fraccionSeleccionadaNombre"
              type="text"
              readonly
              @click="abrirModalFraccion"
              class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200 cursor-pointer"
              placeholder="Seleccione una fracción"
            />
            <button
              type="button"
              @click="abrirModalFraccion"
              class="absolute right-1 top-1/2 -translate-y-1/2 p-1 hover:bg-gray-200 dark:hover:bg-gray-700 rounded"
            >
              <svg class="w-4 h-4 text-gray-600 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
              </svg>
            </button>
          </div>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Folio (Auto-generado)
          </label>
          <input
            :value="folioGenerado"
            type="text"
            readonly
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-100 dark:bg-gray-700 dark:border-gray-600 text-gray-600 dark:text-gray-300 cursor-not-allowed"
            placeholder="Se genera automáticamente"
          />
          <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">Cliente-Proyecto-Fracción</p>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Fecha *
          </label>
          <input
            v-model="formData.fecha"
            type="date"
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Estado
          </label>
          <select
            v-model="formData.estado"
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200"
          >
            <option value="Borrador">Borrador</option>
            <option value="Cotizado">Cotizado</option>
            <option value="Aprobado">Aprobado</option>
            <option value="Rechazado">Rechazado</option>
            <option value="Cancelado">Cancelado</option>
          </select>
        </div>

        <!-- Dimensiones -->
        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Largo (cm)
          </label>
          <input
            v-model.number="formData.largo"
            type="number"
            step="0.01"
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200"
            placeholder="0.00"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ancho (cm)
          </label>
          <input
            v-model.number="formData.ancho"
            type="number"
            step="0.01"
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200"
            placeholder="0.00"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Alto (cm)
          </label>
          <input
            v-model.number="formData.alto"
            type="number"
            step="0.01"
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200"
            placeholder="0.00"
          />
        </div>

        <!-- Dimensiones Papel -->
        <div class="md:col-span-2 border-t border-gray-200 dark:border-gray-700 pt-3 mt-2">
          <h3 class="text-sm font-semibold text-blue-600 dark:text-blue-400 mb-2">Dimensiones Papel</h3>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ancho Papel (cm)
          </label>
          <input
            v-model.number="formData.anchoPapel"
            type="number"
            step="0.01"
            class="w-full px-2 py-1.5 text-sm rounded border bg-blue-50 dark:bg-blue-900/20 dark:border-blue-700 focus:outline-none focus:ring-1 focus:ring-blue-200"
            placeholder="0.00"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Largo Papel (cm)
          </label>
          <input
            v-model.number="formData.largoPapel"
            type="number"
            step="0.01"
            class="w-full px-2 py-1.5 text-sm rounded border bg-blue-50 dark:bg-blue-900/20 dark:border-blue-700 focus:outline-none focus:ring-1 focus:ring-blue-200"
            placeholder="0.00"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Área Papel (m²)
          </label>
          <input
            :value="areaPapelCalculada"
            type="text"
            readonly
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-100 dark:bg-gray-700 dark:border-gray-600 text-gray-600 dark:text-gray-300"
            placeholder="0.0000"
          />
        </div>

        <!-- Dimensiones Corrugado -->
        <div class="md:col-span-2 border-t border-gray-200 dark:border-gray-700 pt-3 mt-2">
          <h3 class="text-sm font-semibold text-green-600 dark:text-green-400 mb-2">Dimensiones Corrugado</h3>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Ancho Corrugado (cm)
          </label>
          <input
            v-model.number="formData.anchoCorrugado"
            type="number"
            step="0.01"
            class="w-full px-2 py-1.5 text-sm rounded border bg-green-50 dark:bg-green-900/20 dark:border-green-700 focus:outline-none focus:ring-1 focus:ring-green-200"
            placeholder="0.00"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Largo Corrugado (cm)
          </label>
          <input
            v-model.number="formData.largoCorrugado"
            type="number"
            step="0.01"
            class="w-full px-2 py-1.5 text-sm rounded border bg-green-50 dark:bg-green-900/20 dark:border-green-700 focus:outline-none focus:ring-1 focus:ring-green-200"
            placeholder="0.00"
          />
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Área Corrugado (m²)
          </label>
          <input
            :value="areaCorrugadoCalculada"
            type="text"
            readonly
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-100 dark:bg-gray-700 dark:border-gray-600 text-gray-600 dark:text-gray-300"
            placeholder="0.0000"
          />
        </div>

        <!-- Cantidades de Empaque -->
        <div class="md:col-span-2 border-t border-gray-200 dark:border-gray-700 pt-3 mt-2">
          <div class="flex items-start gap-2 mb-3">
            <h3 class="text-sm font-semibold text-orange-600 dark:text-orange-400">Cantidades de Empaque</h3>
            <div class="group relative">
              <svg class="w-4 h-4 text-blue-500 dark:text-blue-400 cursor-help" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
              </svg>
              <div class="invisible group-hover:visible absolute z-10 w-72 p-3 bg-blue-900 text-white text-xs rounded-lg shadow-lg -right-2 top-6">
                <p class="font-semibold mb-2">📦 Estos valores se usan para calcular costos de empaque y envío:</p>
                <ul class="space-y-1 text-[11px]">
                  <li>• <strong>EMPAQUE PRIMARIO:</strong> Costo ÷ Cantidad por Paquete</li>
                  <li>• <strong>TARIMA:</strong> Costo ÷ (Cant. × Paquetes)</li>
                  <li>• <strong>ENVÍO:</strong> Costo ÷ (Cant. × Paquetes × Tar x Unidad)</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Cantidad por Paquete
          </label>
          <input
            v-model.number="formData.cantidadPorPaquete"
            type="number"
            step="0.01"
            min="1"
            class="w-full px-2 py-1.5 text-sm rounded border bg-orange-50 dark:bg-orange-900/20 dark:border-orange-700 focus:outline-none focus:ring-1 focus:ring-orange-200"
            placeholder="1"
          />
          <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">Unidades que caben en un paquete</p>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Paquetes por Tarima
          </label>
          <input
            v-model.number="formData.paquetesPorTarima"
            type="number"
            step="0.01"
            min="1"
            class="w-full px-2 py-1.5 text-sm rounded border bg-orange-50 dark:bg-orange-900/20 dark:border-orange-700 focus:outline-none focus:ring-1 focus:ring-orange-200"
            placeholder="1"
          />
          <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">Paquetes que caben en una tarima</p>
        </div>

        <!-- Campos de Producción -->
        <div class="md:col-span-2 border-t border-gray-200 dark:border-gray-700 pt-3 mt-2">
          <h3 class="text-sm font-semibold text-purple-600 dark:text-purple-400 mb-2">Producción</h3>
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Poses *
          </label>
          <input
            v-model.number="formData.poses"
            type="number"
            min="1"
            class="w-full px-2 py-1.5 text-sm rounded border bg-purple-50 dark:bg-purple-900/20 dark:border-purple-700 focus:outline-none focus:ring-1 focus:ring-purple-200"
            placeholder="1"
          />
          <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">Número de poses en la producción</p>
        </div>

        <div class="md:col-span-2">
          <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
            Descripción
          </label>
          <textarea
            v-model="formData.descripcion"
            rows="2"
            class="w-full px-2 py-1.5 text-sm rounded border bg-gray-50 dark:bg-gray-900 dark:border-gray-700 focus:outline-none focus:ring-1 focus:ring-violet-200"
            placeholder="Descripción del prototipo"
          ></textarea>
        </div>
      </div>

      <div class="p-6 border-t border-gray-200 dark:border-gray-700 flex justify-end gap-2">
        <router-link
          to="/prototipos-new"
          class="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-200 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition"
        >
          Cancelar
        </router-link>
        <button
          @click="guardarPrototipo"
          :disabled="loading"
          class="px-4 py-2 bg-violet-600 hover:bg-violet-700 text-white rounded-lg transition disabled:opacity-50"
        >
          {{ loading ? 'Guardando...' : 'Guardar Prototipo' }}
        </button>
      </div>
    </div>

    <!-- Resumen de Costos (collapsible, collapsed by default) -->
    <details v-if="false && seccionesLocales.length > 0" class="bg-gradient-to-r from-violet-50 to-purple-50 dark:from-gray-800 dark:to-gray-900 rounded-lg shadow-sm border border-violet-200 dark:border-violet-800 mb-6">
      <summary class="cursor-pointer p-4 font-semibold text-violet-900 dark:text-violet-300 text-lg hover:bg-violet-100 dark:hover:bg-gray-800 rounded-lg transition-colors flex items-center justify-between">
        <span>💰 Resumen de Costos</span>
        <svg class="w-5 h-5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </summary>

      <div class="p-6 space-y-4 border-t border-violet-200 dark:border-violet-700">
        <!-- Resumen de Totales -->
        <div class="bg-white dark:bg-gray-800 rounded-lg p-4 border-2 border-violet-300 dark:border-violet-700">
          <p class="text-sm font-bold text-violet-900 dark:text-violet-300 mb-3">📊 Totales de Costos</p>

          <div class="grid grid-cols-2 gap-3 mb-3">
            <div class="bg-green-50 dark:bg-green-900/20 rounded p-2 border border-green-200 dark:border-green-700">
              <p class="text-[9px] text-gray-600 dark:text-gray-400">Costos Afectados por Poses</p>
              <p class="text-base font-bold text-green-700 dark:text-green-400">
                ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) }}
              </p>
            </div>

            <div class="bg-purple-50 dark:bg-purple-900/20 rounded p-2 border border-purple-200 dark:border-purple-700">
              <p class="text-[9px] text-gray-600 dark:text-gray-400">Costos Adicionales</p>
              <p class="text-base font-bold text-purple-700 dark:text-purple-400">
                ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAdicionales : costosClasificadosLocal.sumaCostosAdicionales) }}
              </p>
            </div>

            <div class="bg-orange-50 dark:bg-orange-900/20 rounded p-2 border border-orange-200 dark:border-orange-700">
              <p class="text-[9px] text-gray-600 dark:text-gray-400">Costos de Ajuste (total)</p>
              <p class="text-base font-bold text-orange-700 dark:text-orange-400">
                ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAjuste : costosClasificadosLocal.sumaCostosAjuste) }}
              </p>
            </div>

            <div class="bg-blue-50 dark:bg-blue-900/20 rounded p-2 border border-blue-200 dark:border-blue-700">
              <p class="text-[9px] text-gray-600 dark:text-gray-400">Herramentales</p>
              <p class="text-base font-bold text-blue-700 dark:text-blue-400">
                ${{ formatCurrency(isEditing && prototipo ? prototipo.costoHerramentales : costosClasificadosLocal.costoHerramentales) }}
              </p>
            </div>
          </div>

          <div class="border-t border-violet-200 dark:border-violet-700 pt-3 mt-3">
            <p class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-1">💎 Costo Unitario Total</p>
            <p class="text-3xl font-bold text-violet-600 dark:text-violet-400">
              ${{ formatCurrency(isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) }}
            </p>
            <p class="text-[10px] text-gray-500 dark:text-gray-400 mt-1">
              Costo final por pieza producida (base + adicionales)
            </p>
          </div>
        </div>

        <!-- DEBUG: Cálculo de Precios -->
        <details class="bg-gradient-to-r from-amber-50 to-yellow-50 dark:from-amber-900/20 dark:to-yellow-900/20 rounded-lg border border-amber-300 dark:border-amber-700">
          <summary class="cursor-pointer p-3 font-semibold text-amber-900 dark:text-amber-300 text-sm hover:bg-amber-100 dark:hover:bg-amber-900/30 rounded-lg transition-colors">
            🔍 DEBUG - Cálculo de Costos y Precios
          </summary>

          <div class="p-4 space-y-3 text-xs border-t border-amber-200 dark:border-amber-700">
            <!-- Paso 1: Cálculo del Costo Unitario -->
            <div class="bg-white dark:bg-gray-800 rounded p-3 border border-gray-200 dark:border-gray-600">
              <p class="font-bold text-gray-800 dark:text-gray-200 mb-2">📐 Paso 1: Costo Unitario</p>
              <div class="space-y-1 font-mono text-[10px]">
                <p class="text-green-700 dark:text-green-400">
                  Costos Afectados por Poses: ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) }}
                </p>
                <p class="text-green-700 dark:text-green-400">
                  Poses: {{ (isEditing && prototipo ? prototipo.poses : formData.poses) || 1 }}
                </p>
                <p class="text-green-700 dark:text-green-400">
                  Base por pieza = ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) }} ÷ {{ (isEditing && prototipo ? prototipo.poses : formData.poses) || 1 }} =
                  <span class="font-bold">${{ formatCurrency((isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) / ((isEditing && prototipo ? prototipo.poses : formData.poses) || 1)) }}</span>
                </p>
                <div class="border-t border-gray-300 dark:border-gray-600 my-2"></div>
                <p class="text-purple-700 dark:text-purple-400">
                  + Costos Adicionales: ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAdicionales : costosClasificadosLocal.sumaCostosAdicionales) }}
                </p>
                <div class="border-t border-gray-300 dark:border-gray-600 my-2"></div>
                <p class="text-violet-700 dark:text-violet-400 font-bold text-sm">
                  = Costo Unitario: ${{ formatCurrency(isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) }}
                </p>
              </div>
            </div>

            <!-- Paso 2: Costo de Ajuste -->
            <div class="bg-white dark:bg-gray-800 rounded p-3 border border-gray-200 dark:border-gray-600">
              <p class="font-bold text-gray-800 dark:text-gray-200 mb-2">⚙️ Paso 2: Costo de Ajuste (variable)</p>
              <div class="space-y-1 font-mono text-[10px]">
                <p class="text-orange-700 dark:text-orange-400">
                  Suma Costos de Ajuste: ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAjuste : costosClasificadosLocal.sumaCostosAjuste) }}
                </p>
                <p class="text-orange-700 dark:text-orange-400">
                  Cantidad: {{ (isEditing && prototipo ? prototipo.cantidad : formData.cantidad) || 1 }}
                </p>
                <p class="text-orange-700 dark:text-orange-400">
                  Costo Ajuste = ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAjuste : costosClasificadosLocal.sumaCostosAjuste) }} ÷ {{ (isEditing && prototipo ? prototipo.cantidad : formData.cantidad) || 1 }} =
                  <span class="font-bold">${{ formatCurrency((isEditing && prototipo ? prototipo.sumaCostosAjuste : costosClasificadosLocal.sumaCostosAjuste) / ((isEditing && prototipo ? prototipo.cantidad : formData.cantidad) || 1)) }}</span>
                </p>
                <p class="text-[9px] text-orange-600 dark:text-orange-400 italic mt-2">
                  ⚠️ En cotizaciones se recalcula según la cantidad real del pedido
                </p>
              </div>
            </div>

            <!-- Paso 3: Precio de Venta -->
            <div class="bg-white dark:bg-gray-800 rounded p-3 border border-gray-200 dark:border-gray-600">
              <p class="font-bold text-gray-800 dark:text-gray-200 mb-2">💰 Paso 3: Precios de Venta (4 opciones)</p>
              <div class="space-y-2 font-mono text-[10px]">
                <p class="text-gray-700 dark:text-gray-300 mb-2">
                  Fórmula: <span class="font-bold">Precio Venta = (Costo Unitario + Costo Ajuste) ÷ (1 - Utilidad%) ÷ 0.975</span>
                </p>

                <div class="space-y-1">
                  <p class="text-gray-600 dark:text-gray-400">
                    Costo Total = ${{ formatCurrency(isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) }} +
                    ${{ formatCurrency(isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal) }} =
                    <span class="font-bold text-gray-800 dark:text-gray-200">
                      ${{ formatCurrency((isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) + (isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal)) }}
                    </span>
                  </p>
                </div>

                <div class="border-t border-gray-300 dark:border-gray-600 my-2"></div>

                <p class="font-semibold text-gray-700 dark:text-gray-300 mb-1">Precios según utilidad del negocio:</p>
                <p class="text-blue-600 dark:text-blue-400">
                  Opción 1 ({{ porcentajesNegocio.porcentaje1 }}%): ${{ formatCurrency((isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) + (isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal)) }} ÷ {{ (1 - porcentajesNegocio.porcentaje1 / 100).toFixed(2) }} ÷ 0.975 =
                  <span class="font-bold">${{ formatCurrency(preciosCalculados.precio1) }}</span>
                </p>
                <p class="text-blue-600 dark:text-blue-400">
                  Opción 2 ({{ porcentajesNegocio.porcentaje2 }}%): ${{ formatCurrency((isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) + (isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal)) }} ÷ {{ (1 - porcentajesNegocio.porcentaje2 / 100).toFixed(2) }} ÷ 0.975 =
                  <span class="font-bold">${{ formatCurrency(preciosCalculados.precio2) }}</span>
                </p>
                <p class="text-blue-600 dark:text-blue-400">
                  Opción 3 ({{ porcentajesNegocio.porcentaje3 }}%): ${{ formatCurrency((isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) + (isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal)) }} ÷ {{ (1 - porcentajesNegocio.porcentaje3 / 100).toFixed(2) }} ÷ 0.975 =
                  <span class="font-bold">${{ formatCurrency(preciosCalculados.precio3) }}</span>
                </p>
                <p class="text-blue-600 dark:text-blue-400">
                  Opción 4 ({{ porcentajesNegocio.porcentaje4 }}%): ${{ formatCurrency((isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) + (isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal)) }} ÷ {{ (1 - porcentajesNegocio.porcentaje4 / 100).toFixed(2) }} ÷ 0.975 =
                  <span class="font-bold">${{ formatCurrency(preciosCalculados.precio4) }}</span>
                </p>
              </div>
            </div>

            <!-- Paso 4: Herramentales -->
            <div class="bg-blue-50 dark:bg-blue-900/20 rounded p-3 border border-blue-300 dark:border-blue-700">
              <p class="font-bold text-blue-800 dark:text-blue-200 mb-2">🔧 Herramentales (cargo único)</p>
              <div class="space-y-1 font-mono text-[10px]">
                <p class="text-blue-700 dark:text-blue-400">
                  Total Herramentales: <span class="font-bold">${{ formatCurrency(isEditing && prototipo ? prototipo.costoHerramentales : costosClasificadosLocal.costoHerramentales) }}</span>
                </p>
                <p class="text-[9px] text-blue-600 dark:text-blue-400 italic mt-2">
                  💡 Se cobra una sola vez, no se multiplica por cantidad
                </p>
              </div>
            </div>
          </div>
        </details>

        <!-- Grid 2 columnas para costos base -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Desglose: Costos Base (Afectados por Poses) -->
          <div class="bg-gradient-to-br from-green-50 to-emerald-50 dark:from-green-900/20 dark:to-emerald-900/30 rounded-lg p-4 border border-green-300 dark:border-green-700">
            <p class="text-xs font-semibold text-green-700 dark:text-green-300 mb-3 flex items-center gap-1">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"/>
              </svg>
              📊 Costos Base
            </p>
            <div class="space-y-2">
              <div class="flex justify-between items-center">
                <span class="text-[10px] text-gray-600 dark:text-gray-400">Suma total:</span>
                <span class="text-sm font-bold text-green-700 dark:text-green-400">
                  ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) }}
                </span>
              </div>
              <div class="flex justify-between items-center">
                <span class="text-[10px] text-gray-600 dark:text-gray-400">Poses:</span>
                <span class="text-sm font-semibold text-green-600 dark:text-green-300">
                  {{ (isEditing && prototipo ? prototipo.poses : formData.poses) || 1 }}
                </span>
              </div>
              <div class="pt-2 border-t border-green-200 dark:border-green-800">
                <div class="flex justify-between items-center">
                  <span class="text-[10px] font-medium text-gray-700 dark:text-gray-300">Por pieza:</span>
                  <span class="text-lg font-bold text-green-600 dark:text-green-300">
                    ${{ formatCurrency((isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) / ((isEditing && prototipo ? prototipo.poses : formData.poses) || 1)) }}
                  </span>
                </div>
              </div>
            </div>
            <p class="text-[9px] text-green-600 dark:text-green-400 mt-2 italic">
              Materias primas, impresión, procesos
            </p>
          </div>

          <!-- Desglose: Costos Adicionales -->
          <div class="bg-gradient-to-br from-purple-50 to-violet-50 dark:from-purple-900/20 dark:to-violet-900/30 rounded-lg p-4 border border-purple-300 dark:border-purple-700">
            <p class="text-xs font-semibold text-purple-700 dark:text-purple-300 mb-3 flex items-center gap-1">
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"/>
              </svg>
              ➕ Costos Adicionales
            </p>
            <div class="space-y-2">
              <div class="flex justify-between items-center">
                <span class="text-[10px] text-gray-600 dark:text-gray-400">Total directo:</span>
                <span class="text-lg font-bold text-purple-700 dark:text-purple-400">
                  ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAdicionales : costosClasificadosLocal.sumaCostosAdicionales) }}
                </span>
              </div>
              <div class="pt-2 mt-2 border-t border-purple-200 dark:border-purple-800">
                <p class="text-[10px] text-purple-600 dark:text-purple-400">
                  ✓ No se dividen entre poses
                </p>
                <p class="text-[10px] text-purple-600 dark:text-purple-400">
                  ✓ Se suman tal cual al costo
                </p>
              </div>
            </div>
            <p class="text-[9px] text-purple-600 dark:text-purple-400 mt-2 italic">
              Empaques, envío, servicios extras
            </p>
          </div>
        </div>

        <!-- Sección de Costos que se Dividen -->
        <div class="bg-gradient-to-r from-orange-50 via-amber-50 to-yellow-50 dark:from-orange-900/20 dark:via-amber-900/20 dark:to-yellow-900/20 rounded-lg p-4 border border-orange-300 dark:border-orange-700">
          <p class="text-xs font-semibold text-orange-700 dark:text-orange-300 mb-3 flex items-center gap-1">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            ⚙️ Costos de Ajuste (Se dividen en cotizaciones)
          </p>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <p class="text-[10px] text-gray-600 dark:text-gray-400 mb-1">Suma guardada:</p>
              <p class="text-xl font-bold text-orange-700 dark:text-orange-400">
                ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAjuste : costosClasificadosLocal.sumaCostosAjuste) }}
              </p>
            </div>
            <div>
              <p class="text-[10px] text-gray-600 dark:text-gray-400 mb-1">Con cantidad = 1:</p>
              <p class="text-xl font-bold text-orange-600 dark:text-orange-300">
                ${{ formatCurrency(isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal) }}
              </p>
            </div>
          </div>
          <div class="mt-3 pt-3 border-t border-orange-200 dark:border-orange-800">
            <p class="text-[10px] text-orange-700 dark:text-orange-300 font-medium mb-1">
              📐 En cotizaciones:
            </p>
            <p class="text-[9px] text-orange-600 dark:text-orange-400">
              Suma ÷ Cantidad Real del Pedido = Costo Ajuste Unitario
            </p>
            <p class="text-[9px] text-orange-600 dark:text-orange-400 italic mt-1">
              Ejemplo: $1,000 ÷ 5,000 pzas = $0.20 por pieza
            </p>
          </div>
        </div>

        <!-- Desglose: Herramentales -->
        <div class="bg-gradient-to-br from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/30 rounded-lg p-4 border-2 border-blue-300 dark:border-blue-700">
          <p class="text-xs font-semibold text-blue-700 dark:text-blue-300 mb-3 flex items-center gap-1">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            </svg>
            🔧 Inversión en Herramentales
          </p>
          <div class="flex items-center justify-between mb-2">
            <div>
              <p class="text-[10px] text-gray-600 dark:text-gray-400">Costo único de inversión:</p>
              <p class="text-2xl font-bold text-blue-700 dark:text-blue-400">
                ${{ formatCurrency(isEditing && prototipo ? prototipo.costoHerramentales : costosClasificadosLocal.costoHerramentales) }}
              </p>
            </div>
            <div class="text-right">
              <div class="bg-blue-100 dark:bg-blue-900/40 rounded-lg px-3 py-2">
                <p class="text-[9px] text-blue-600 dark:text-blue-400">Inversión inicial</p>
                <p class="text-[9px] font-semibold text-blue-700 dark:text-blue-300">No se repite</p>
              </div>
            </div>
          </div>
          <div class="pt-2 border-t border-blue-200 dark:border-blue-800">
            <p class="text-[9px] text-blue-600 dark:text-blue-400">
              💡 Moldes, troqueles, suajes, placas - Se cobran una sola vez al inicio del proyecto
            </p>
          </div>
        </div>

        <!-- Info sobre cantidad -->
        <div class="bg-indigo-50 dark:bg-indigo-900/20 rounded-lg p-3 border border-indigo-200 dark:border-indigo-700">
          <p class="text-xs font-medium text-indigo-700 dark:text-indigo-300 flex items-center gap-1 mb-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
            </svg>
            💡 ¿Cómo funcionan los costos?
          </p>
          <div class="space-y-1 text-[10px] text-indigo-600 dark:text-indigo-400">
            <p>✓ <strong>Costos Base:</strong> Se dividen entre poses (ej: material por juego completo)</p>
            <p>✓ <strong>Costos Adicionales:</strong> Se suman directos sin dividir (ej: empaque final)</p>
            <p>✓ <strong>Costos de Ajuste:</strong> Se dividen en cotización según cantidad real (ej: setup de máquina)</p>
            <p>✓ <strong>Herramentales:</strong> Inversión única que se cotiza por separado</p>
          </div>
        </div>
      </div>
    </details>

    <!-- DEBUG: Fórmulas de Cálculo (collapsible, collapsed by default) -->
    <details v-if="false && seccionesLocales.length > 0" class="bg-gradient-to-r from-slate-50 to-gray-50 dark:from-slate-900 dark:to-gray-900 rounded-lg shadow-sm border-2 border-slate-300 dark:border-slate-700 mb-6">
      <summary class="cursor-pointer p-4 font-bold text-slate-900 dark:text-slate-100 text-lg hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg transition-colors flex items-center justify-between">
        <span class="flex items-center gap-2">
          <span class="text-2xl">🔍</span>
          DEBUG - FÓRMULAS DE CÁLCULO
        </span>
        <svg class="w-5 h-5 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
        </svg>
      </summary>

      <div class="p-6 space-y-4 border-t border-slate-300 dark:border-slate-700">
        <!-- 1. Datos Base -->
        <div class="bg-white dark:bg-gray-800 rounded-lg p-4 border border-slate-200 dark:border-slate-600">
          <h4 class="font-bold text-slate-900 dark:text-slate-100 mb-3 flex items-center gap-2">
            <span class="text-blue-600 dark:text-blue-400">1️⃣</span> DATOS BASE
          </h4>
          <div class="grid grid-cols-2 gap-3 text-sm font-mono">
            <div class="flex justify-between border-b border-slate-200 dark:border-slate-700 pb-1">
              <span class="text-slate-600 dark:text-slate-400">Poses:</span>
              <span class="font-bold text-slate-900 dark:text-slate-100">{{ (isEditing && prototipo ? prototipo.poses : formData.poses) || 1 }}</span>
            </div>
            <div class="flex justify-between border-b border-slate-200 dark:border-slate-700 pb-1">
              <span class="text-slate-600 dark:text-slate-400">Cantidad:</span>
              <span class="font-bold text-slate-900 dark:text-slate-100">{{ (isEditing && prototipo ? prototipo.cantidad : formData.cantidad) || 1 }}</span>
            </div>
          </div>

          <!-- Detalle Costos Afectados por Poses -->
          <div class="mt-4 p-3 bg-green-50 dark:bg-green-900/10 rounded border border-green-200 dark:border-green-700">
            <div class="flex justify-between items-center mb-2">
              <span class="text-green-600 dark:text-green-400 font-bold">Σ Costos Afectados Poses:</span>
              <span class="font-bold text-green-700 dark:text-green-300">${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) }}</span>
            </div>
            <div v-if="costosClasificadosLocal.detalleAfectadosPorPoses?.length > 0" class="text-xs space-y-1 pl-2 border-l-2 border-green-300 dark:border-green-600">
              <div v-for="(item, idx) in costosClasificadosLocal.detalleAfectadosPorPoses" :key="idx" class="flex flex-col gap-1 text-green-700 dark:text-green-300 pb-2 border-b border-green-100 dark:border-green-800">
                <div class="flex justify-between">
                  <span class="font-semibold">• {{ item.catalogo }} - {{ item.campo }}</span>
                  <span class="font-mono font-bold">${{ formatCurrency(item.valor) }}</span>
                </div>
                <div class="flex justify-between text-[10px] text-green-600 dark:text-green-400 pl-3">
                  <span>📐 {{ item.tipoCalculo }}</span>
                  <span v-if="item.tipoCalculo !== 'valor_directo'">(original: ${{ formatCurrency(item.valorOriginal) }})</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Detalle Costos Adicionales -->
          <div class="mt-3 p-3 bg-purple-50 dark:bg-purple-900/10 rounded border border-purple-200 dark:border-purple-700">
            <div class="flex justify-between items-center mb-2">
              <span class="text-purple-600 dark:text-purple-400 font-bold">Σ Costos Adicionales:</span>
              <span class="font-bold text-purple-700 dark:text-purple-300">${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAdicionales : costosClasificadosLocal.sumaCostosAdicionales) }}</span>
            </div>
            <div v-if="costosClasificadosLocal.detalleAdicionales?.length > 0" class="text-xs space-y-1 pl-2 border-l-2 border-purple-300 dark:border-purple-600">
              <div v-for="(item, idx) in costosClasificadosLocal.detalleAdicionales" :key="idx" class="flex flex-col gap-1 text-purple-700 dark:text-purple-300 pb-2 border-b border-purple-100 dark:border-purple-800">
                <div class="flex justify-between">
                  <span class="font-semibold">• {{ item.catalogo }} - {{ item.campo }}</span>
                  <span class="font-mono font-bold">${{ formatCurrency(item.valor) }}</span>
                </div>
                <div class="flex justify-between text-[10px] text-purple-600 dark:text-purple-400 pl-3">
                  <span>📐 {{ item.tipoCalculo }}</span>
                  <span v-if="item.tipoCalculo !== 'valor_directo'">(original: ${{ formatCurrency(item.valorOriginal) }})</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Detalle Costos Ajuste -->
          <div class="mt-3 p-3 bg-orange-50 dark:bg-orange-900/10 rounded border border-orange-200 dark:border-orange-700">
            <div class="flex justify-between items-center mb-2">
              <span class="text-orange-600 dark:text-orange-400 font-bold">Σ Costos Ajuste (total):</span>
              <span class="font-bold text-orange-700 dark:text-orange-300">${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAjuste : costosClasificadosLocal.sumaCostosAjuste) }}</span>
            </div>
            <div v-if="costosClasificadosLocal.detalleAjuste?.length > 0" class="text-xs space-y-1 pl-2 border-l-2 border-orange-300 dark:border-orange-600">
              <div v-for="(item, idx) in costosClasificadosLocal.detalleAjuste" :key="idx" class="flex flex-col gap-1 text-orange-700 dark:text-orange-300 pb-2 border-b border-orange-100 dark:border-orange-800">
                <div class="flex justify-between">
                  <span class="font-semibold">• {{ item.catalogo }} - {{ item.campo }}</span>
                  <span class="font-mono font-bold">${{ formatCurrency(item.valor) }}</span>
                </div>
                <div class="flex justify-between text-[10px] text-orange-600 dark:text-orange-400 pl-3">
                  <span>📐 {{ item.tipoCalculo }}</span>
                  <span v-if="item.tipoCalculo !== 'valor_directo'">(original: ${{ formatCurrency(item.valorOriginal) }})</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Detalle Herramentales -->
          <div class="mt-3 p-3 bg-blue-50 dark:bg-blue-900/10 rounded border border-blue-200 dark:border-blue-700">
            <div class="flex justify-between items-center mb-2">
              <span class="text-blue-600 dark:text-blue-400 font-bold">Σ Herramentales:</span>
              <span class="font-bold text-blue-700 dark:text-blue-300">${{ formatCurrency(isEditing && prototipo ? prototipo.costoHerramentales : costosClasificadosLocal.costoHerramentales) }}</span>
            </div>
            <div v-if="costosClasificadosLocal.detalleHerramentales?.length > 0" class="text-xs space-y-1 pl-2 border-l-2 border-blue-300 dark:border-blue-600">
              <div v-for="(item, idx) in costosClasificadosLocal.detalleHerramentales" :key="idx" class="flex flex-col gap-1 text-blue-700 dark:text-blue-300 pb-2 border-b border-blue-100 dark:border-blue-800">
                <div class="flex justify-between">
                  <span class="font-semibold">• {{ item.catalogo }} - {{ item.campo }}</span>
                  <span class="font-mono font-bold">${{ formatCurrency(item.valor) }}</span>
                </div>
                <div class="flex justify-between text-[10px] text-blue-600 dark:text-blue-400 pl-3">
                  <span>📐 {{ item.tipoCalculo }}</span>
                  <span v-if="item.tipoCalculo !== 'valor_directo'">(original: ${{ formatCurrency(item.valorOriginal) }})</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 2. Costo Unitario -->
        <div class="bg-gradient-to-r from-violet-50 to-purple-50 dark:from-violet-900/20 dark:to-purple-900/20 rounded-lg p-4 border-2 border-violet-300 dark:border-violet-700">
          <h4 class="font-bold text-violet-900 dark:text-violet-100 mb-3 flex items-center gap-2">
            <span class="text-violet-600 dark:text-violet-400">2️⃣</span> COSTO UNITARIO
          </h4>
          <div class="space-y-2 text-sm font-mono">
            <div class="text-slate-700 dark:text-slate-300">
              <span class="font-semibold">Fórmula:</span> ((Σ Afectados por Poses) / Poses) + (Σ Adicionales)
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-3 border border-violet-200 dark:border-violet-700">
              <div class="text-green-700 dark:text-green-300">
                = (${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) }} / {{ (isEditing && prototipo ? prototipo.poses : formData.poses) || 1 }}) + ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAdicionales : costosClasificadosLocal.sumaCostosAdicionales) }}
              </div>
              <div class="text-green-700 dark:text-green-300 mt-1">
                = ${{ formatCurrency((isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) / ((isEditing && prototipo ? prototipo.poses : formData.poses) || 1)) }} + ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAdicionales : costosClasificadosLocal.sumaCostosAdicionales) }}
              </div>
              <div class="text-xl font-bold text-violet-700 dark:text-violet-300 mt-2 pt-2 border-t border-violet-300 dark:border-violet-600">
                ✅ COSTO UNITARIO = ${{ formatCurrency(isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) }}
              </div>
            </div>
          </div>
        </div>

        <!-- 3. Costo Ajuste -->
        <div class="bg-gradient-to-r from-orange-50 to-amber-50 dark:from-orange-900/20 dark:to-amber-900/20 rounded-lg p-4 border-2 border-orange-300 dark:border-orange-700">
          <h4 class="font-bold text-orange-900 dark:text-orange-100 mb-3 flex items-center gap-2">
            <span class="text-orange-600 dark:text-orange-400">3️⃣</span> COSTO AJUSTE (unitario)
          </h4>
          <div class="space-y-2 text-sm font-mono">
            <div class="text-slate-700 dark:text-slate-300">
              <span class="font-semibold">Fórmula:</span> (Σ Costos Ajuste) / Cantidad
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-3 border border-orange-200 dark:border-orange-700">
              <div class="text-orange-700 dark:text-orange-300">
                = ${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAjuste : costosClasificadosLocal.sumaCostosAjuste) }} / {{ (isEditing && prototipo ? prototipo.cantidad : formData.cantidad) || 1 }}
              </div>
              <div class="text-xl font-bold text-orange-700 dark:text-orange-300 mt-2 pt-2 border-t border-orange-300 dark:border-orange-600">
                ✅ COSTO AJUSTE = ${{ formatCurrency(isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal) }}
              </div>
            </div>
            <div class="text-xs text-orange-600 dark:text-orange-400 italic mt-2">
              ⚠️ En cotizaciones se recalcula con la cantidad real del pedido
            </div>
          </div>
        </div>

        <!-- 4. Precio Venta -->
        <div class="bg-gradient-to-r from-blue-50 to-cyan-50 dark:from-blue-900/20 dark:to-cyan-900/20 rounded-lg p-4 border-2 border-blue-300 dark:border-blue-700">
          <h4 class="font-bold text-blue-900 dark:text-blue-100 mb-3 flex items-center gap-2">
            <span class="text-blue-600 dark:text-blue-400">4️⃣</span> PRECIO VENTA UNITARIO (4 opciones)
          </h4>
          <div class="space-y-3 text-sm font-mono">
            <div class="text-slate-700 dark:text-slate-300">
              <span class="font-semibold">Fórmula:</span> ((Costo Unitario + Costo Ajuste) / (1 - %Utilidad/100) / 0.975
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-3 border border-blue-200 dark:border-blue-700">
              <div class="text-slate-700 dark:text-slate-300 mb-2">
                Costo Total = ${{ formatCurrency(isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) }} + ${{ formatCurrency(isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal) }} =
                <span class="font-bold text-blue-700 dark:text-blue-300">${{ formatCurrency((isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) + (isEditing && prototipo ? prototipo.costoAjuste : costoAjusteLocal)) }}</span>
              </div>

              <div class="space-y-2 mt-3 pt-3 border-t border-blue-200 dark:border-blue-700">
                <div class="flex justify-between items-center">
                  <span class="text-blue-600 dark:text-blue-400">Opción 1 ({{ porcentajesNegocio.porcentaje1 }}%):</span>
                  <span class="font-bold text-blue-700 dark:text-blue-300">${{ formatCurrency(preciosCalculados.precio1) }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-blue-600 dark:text-blue-400">Opción 2 ({{ porcentajesNegocio.porcentaje2 }}%):</span>
                  <span class="font-bold text-blue-700 dark:text-blue-300">${{ formatCurrency(preciosCalculados.precio2) }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-blue-600 dark:text-blue-400">Opción 3 ({{ porcentajesNegocio.porcentaje3 }}%):</span>
                  <span class="font-bold text-blue-700 dark:text-blue-300">${{ formatCurrency(preciosCalculados.precio3) }}</span>
                </div>
                <div class="flex justify-between items-center">
                  <span class="text-blue-600 dark:text-blue-400">Opción 4 ({{ porcentajesNegocio.porcentaje4 }}%):</span>
                  <span class="font-bold text-blue-700 dark:text-blue-300">${{ formatCurrency(preciosCalculados.precio4) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 5. Herramentales -->
        <div class="bg-gradient-to-r from-indigo-50 to-blue-50 dark:from-indigo-900/20 dark:to-blue-900/20 rounded-lg p-4 border-2 border-indigo-300 dark:border-indigo-700">
          <h4 class="font-bold text-indigo-900 dark:text-indigo-100 mb-3 flex items-center gap-2">
            <span class="text-indigo-600 dark:text-indigo-400">5️⃣</span> COSTO HERRAMENTALES
          </h4>
          <div class="space-y-2 text-sm font-mono">
            <div class="text-slate-700 dark:text-slate-300">
              <span class="font-semibold">Fórmula:</span> Suma de montos herramentales
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-3 border border-indigo-200 dark:border-indigo-700">
              <div class="text-xl font-bold text-indigo-700 dark:text-indigo-300">
                ✅ HERRAMENTALES = ${{ formatCurrency(isEditing && prototipo ? prototipo.costoHerramentales : costosClasificadosLocal.costoHerramentales) }}
              </div>
              <div class="text-xs text-indigo-600 dark:text-indigo-400 italic mt-2">
                💡 Se cobra UNA sola vez (no se multiplica por cantidad)
              </div>
            </div>
          </div>
        </div>

        <!-- Variables guardadas en BD -->
        <div class="bg-gradient-to-r from-emerald-50 to-green-50 dark:from-emerald-900/20 dark:to-green-900/20 rounded-lg p-4 border-2 border-emerald-400 dark:border-emerald-600">
          <h4 class="font-bold text-emerald-900 dark:text-emerald-100 mb-3 flex items-center gap-2">
            <span class="text-emerald-600 dark:text-emerald-400">📦</span> VARIABLES GUARDADAS EN BD (para recalcular en cotizaciones)
          </h4>
          <div class="grid grid-cols-2 gap-2 text-xs font-mono">
            <div class="bg-white dark:bg-gray-800 rounded p-2 border border-emerald-200 dark:border-emerald-700">
              <div class="text-emerald-600 dark:text-emerald-400">✓ costoUnitario</div>
              <div class="font-bold text-emerald-700 dark:text-emerald-300">${{ formatCurrency(isEditing && prototipo ? prototipo.costoUnitario : costoUnitarioLocal) }}</div>
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-2 border border-emerald-200 dark:border-emerald-700">
              <div class="text-emerald-600 dark:text-emerald-400">✓ sumaCostosAjuste</div>
              <div class="font-bold text-emerald-700 dark:text-emerald-300">${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAjuste : costosClasificadosLocal.sumaCostosAjuste) }}</div>
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-2 border border-emerald-200 dark:border-emerald-700">
              <div class="text-emerald-600 dark:text-emerald-400">✓ costoHerramentales</div>
              <div class="font-bold text-emerald-700 dark:text-emerald-300">${{ formatCurrency(isEditing && prototipo ? prototipo.costoHerramentales : costosClasificadosLocal.costoHerramentales) }}</div>
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-2 border border-emerald-200 dark:border-emerald-700">
              <div class="text-emerald-600 dark:text-emerald-400">✓ poses</div>
              <div class="font-bold text-emerald-700 dark:text-emerald-300">{{ (isEditing && prototipo ? prototipo.poses : formData.poses) || 1 }}</div>
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-2 border border-emerald-200 dark:border-emerald-700">
              <div class="text-emerald-600 dark:text-emerald-400">✓ sumaCostosAfectadosPorPoses</div>
              <div class="font-bold text-emerald-700 dark:text-emerald-300">${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAfectadosPorPoses : costosClasificadosLocal.sumaCostosAfectadosPorPoses) }}</div>
            </div>
            <div class="bg-white dark:bg-gray-800 rounded p-2 border border-emerald-200 dark:border-emerald-700">
              <div class="text-emerald-600 dark:text-emerald-400">✓ sumaCostosAdicionales</div>
              <div class="font-bold text-emerald-700 dark:text-emerald-300">${{ formatCurrency(isEditing && prototipo ? prototipo.sumaCostosAdicionales : costosClasificadosLocal.sumaCostosAdicionales) }}</div>
            </div>
          </div>
        </div>
      </div>
    </details>

    <!-- Secciones del prototipo -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="p-6 border-b border-gray-200 dark:border-gray-700">
        <div class="flex justify-between items-center">
          <h2 class="text-lg font-semibold text-gray-900 dark:text-white">
            Secciones y Catálogos
          </h2>
          <button
            @click="showSeccionModal = true"
            class="bg-violet-600 hover:bg-violet-700 text-white px-4 py-2 rounded-lg transition-colors duration-200 flex items-center gap-2"
          >
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
            Agregar Sección
          </button>
        </div>
      </div>

      <div class="p-6">
        <div v-if="seccionesActuales.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
          No hay secciones agregadas. Haz clic en "Agregar Sección" para comenzar.
        </div>
        
        <div v-else class="space-y-6">
          <div
            v-for="(seccion, seccionIndex) in seccionesActuales"
            :key="seccion.prototipoSeccionId || seccionIndex"
            class="border border-gray-200 dark:border-gray-700 rounded-lg p-3"
          >
            <div class="flex justify-between items-center mb-3">
              <h3 class="text-base font-semibold text-gray-900 dark:text-white">
                {{ seccion.seccion?.nombreSeccion }}
              </h3>
              <div class="flex gap-2">
                <button
                  v-if="isEditing && seccion.prototipoSeccionId"
                  @click="sincronizarSeccion(seccion.prototipoSeccionId)"
                  :disabled="loading"
                  class="px-3 py-1 text-xs bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition disabled:opacity-50 flex items-center gap-1"
                  title="Sincronizar catálogos con los actuales de la sección"
                >
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
                  </svg>
                  Sincronizar
                </button>
                <button
                  @click="eliminarSeccion(seccionIndex)"
                  :disabled="loading"
                  class="px-3 py-1 text-xs bg-red-600 hover:bg-red-700 text-white rounded-lg transition disabled:opacity-50 flex items-center gap-1"
                  title="Eliminar esta sección del prototipo"
                >
                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                  </svg>
                  Eliminar
                </button>
              </div>
            </div>

            <div class="space-y-2">
              <div
                v-for="(componente, componenteIndex) in seccion.componentes"
                :key="componente.prototipoComponenteId || componenteIndex"
                class="border border-gray-200 dark:border-gray-700 rounded-lg p-2 bg-white dark:bg-gray-900"
              >
                <!-- <pre>
                  {{ seccion }}
                </pre> -->
                <div class="flex items-start gap-2">
                  <div class="flex-1">
                    <div class="mb-2">
                      <div class="flex items-center gap-2">
                        <div class="text-sm font-bold text-violet-600 dark:text-violet-400">
                          {{ componente.nombreMostrar || componente.catalogo?.nombreCatalogo }}
                        </div>
                        <span v-if="hasCamposCalculados(componente)" class="text-[10px] px-1.5 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-700 dark:text-blue-400 rounded" title="Este catálogo tiene campos calculados">
                          🔢 Calculado
                        </span>
                      </div>
                      <div v-if="componente.nombreMostrar" class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                        {{ componente.catalogo?.nombreCatalogo }}
                      </div>
                      <div v-if="componente.registro?.descripcion" class="text-xs text-gray-500 dark:text-gray-400 mt-0.5 italic">
                        Seleccionado: {{ componente.registro.descripcion }}
                      </div>
                    </div>
                    <SearchableSelect
                      :model-value="componente.registroId"
                      @change="actualizarComponente(seccionIndex, componenteIndex, $event)"
                      :options="getRegistrosParaCatalogo(componente.catalogoId)"
                      label-key="descripcion"
                      value-key="registroId"
                      placeholder="Seleccionar opción..."
                      search-placeholder="Buscar registro..."
                    />
                  </div>

                  <!-- Costo calculado del componente -->
                  <div v-if="componente.costoCalculado" class="text-right">
                    <div class="text-xs text-gray-500 dark:text-gray-400 mb-1">Costo</div>
                    <div class="text-sm font-bold text-green-600 dark:text-green-400">
                      ${{ formatCurrency(componente.costoCalculado) }}
                    </div>
                  </div>
                </div>

                <!-- Mostrar valores del registro seleccionado -->
                <div v-if="componente.registro && componente.registro.valores_campo" class="mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
                  <div class="font-medium text-gray-700 dark:text-gray-300 mb-2 text-xs">Valores del Componente:</div>
                  <div class="grid grid-cols-2 gap-2">
                    <div
                      v-for="valor in componente.registro.valores_campo"
                      :key="valor.valorId"
                      class="flex flex-col p-1.5 rounded text-xs"
                      :class="valor.campo?.esMonto ? 'bg-green-50 dark:bg-green-900/20' : 'bg-gray-50 dark:bg-gray-800'"
                    >
                      <div class="flex justify-between items-start">
                        <span class="text-gray-600 dark:text-gray-400 flex items-center gap-1">
                          {{ valor.campo?.nombreCampo }}
                          <span v-if="valor.campo?.esMonto" class="text-xs text-green-600 dark:text-green-400">($)</span>
                          <span v-if="valor.campo?.esCalculado" class="text-[9px] text-blue-600 dark:text-blue-400" title="Campo calculado automáticamente">🔢</span>
                        </span>
                        <span class="font-medium" :class="valor.campo?.esMonto ? 'text-green-700 dark:text-green-400' : 'text-gray-900 dark:text-white'">
                          {{ formatCurrency(valor.valorNumerico) }}
                        </span>
                      </div>
                      <!-- Mostrar fórmula si es calculado -->
                      <div v-if="valor.campo?.esCalculado && valor.campo?.tipoCalculo" class="text-[9px] text-blue-600 dark:text-blue-400 mt-1 italic">
                        {{ getTipoCalculoLabel(valor.campo.tipoCalculo) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      </div>
      <!-- Fin Columna Principal -->

      <!-- Panel Lateral (1/3) -->
      <div class="space-y-6" v-if="false">
        <!-- Precios de Venta -->
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4">
          <h2 class="text-base font-semibold text-gray-900 dark:text-white mb-3">
            Precios de Venta
            <span v-if="userStore.negocioSeleccionado" class="text-xs font-normal text-gray-500 dark:text-gray-400 ml-2">
              ({{ userStore.negocioSeleccionado.nombre }})
            </span>
          </h2>

          <!-- Información del negocio y porcentajes -->
          <div v-if="userStore.negocioSeleccionado" class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3 mb-4">
            <h3 class="text-sm font-medium text-blue-900 dark:text-blue-200 mb-2">Porcentajes de Ganancia Configurados</h3>
            <div class="grid grid-cols-2 gap-2">
              <div class="flex justify-between">
                <span class="text-xs text-blue-700 dark:text-blue-300">Precio 1:</span>
                <span class="text-xs font-medium text-blue-800 dark:text-blue-200">{{ porcentajesNegocio.porcentaje1 }}%</span>
              </div>
              <div class="flex justify-between">
                <span class="text-xs text-blue-700 dark:text-blue-300">Precio 2:</span>
                <span class="text-xs font-medium text-blue-800 dark:text-blue-200">{{ porcentajesNegocio.porcentaje2 }}%</span>
              </div>
              <div class="flex justify-between">
                <span class="text-xs text-blue-700 dark:text-blue-300">Precio 3:</span>
                <span class="text-xs font-medium text-blue-800 dark:text-blue-200">{{ porcentajesNegocio.porcentaje3 }}%</span>
              </div>
              <div class="flex justify-between">
                <span class="text-xs text-blue-700 dark:text-blue-300">Precio 4:</span>
                <span class="text-xs font-medium text-blue-800 dark:text-blue-200">{{ porcentajesNegocio.porcentaje4 }}%</span>
              </div>
            </div>
          </div>

          <!-- Precios calculados automáticamente -->
          <div class="grid grid-cols-2 gap-3">
            <div class="bg-gradient-to-r from-blue-50 to-blue-100 dark:from-blue-900/30 dark:to-blue-800/30 p-3 rounded-lg border border-blue-200 dark:border-blue-700">
              <label class="block text-xs font-medium text-blue-700 dark:text-blue-300 mb-1">Precio 1 (+{{ porcentajesNegocio.porcentaje1 }}%)</label>
              <div class="text-lg font-bold text-blue-800 dark:text-blue-200">
                ${{ preciosCalculados.precio1.toFixed(2) }}
              </div>
            </div>

            <div class="bg-gradient-to-r from-green-50 to-green-100 dark:from-green-900/30 dark:to-green-800/30 p-3 rounded-lg border border-green-200 dark:border-green-700">
              <label class="block text-xs font-medium text-green-700 dark:text-green-300 mb-1">Precio 2 (+{{ porcentajesNegocio.porcentaje2 }}%)</label>
              <div class="text-lg font-bold text-green-800 dark:text-green-200">
                ${{ preciosCalculados.precio2.toFixed(2) }}
              </div>
            </div>

            <div class="bg-gradient-to-r from-yellow-50 to-yellow-100 dark:from-yellow-900/30 dark:to-yellow-800/30 p-3 rounded-lg border border-yellow-200 dark:border-yellow-700">
              <label class="block text-xs font-medium text-yellow-700 dark:text-yellow-300 mb-1">Precio 3 (+{{ porcentajesNegocio.porcentaje3 }}%)</label>
              <div class="text-lg font-bold text-yellow-800 dark:text-yellow-200">
                ${{ preciosCalculados.precio3.toFixed(2) }}
              </div>
            </div>

            <div class="bg-gradient-to-r from-purple-50 to-purple-100 dark:from-purple-900/30 dark:to-purple-800/30 p-3 rounded-lg border border-purple-200 dark:border-purple-700">
              <label class="block text-xs font-medium text-purple-700 dark:text-purple-300 mb-1">Precio 4 (+{{ porcentajesNegocio.porcentaje4 }}%)</label>
              <div class="text-lg font-bold text-purple-800 dark:text-purple-200">
                ${{ preciosCalculados.precio4.toFixed(2) }}
              </div>
            </div>
          </div>
        </div>

        <!-- Resumen de Costos -->
        <div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 p-4">
          <h2 class="text-base font-semibold text-gray-900 dark:text-white mb-3">Resumen de Costos</h2>

          <div class="space-y-2 text-xs">
            <div class="flex justify-between border-t border-gray-200 dark:border-gray-600 pt-2">
              <span class="text-gray-600 dark:text-gray-400">Costo Total:</span>
              <span class="font-medium text-green-600 dark:text-green-400">${{ costoTotalLocal.toFixed(2) }}</span>
            </div>
            <div class="flex justify-between text-sm">
              <span class="text-gray-600 dark:text-gray-400">Rango de precios de venta:</span>
              <span class="font-medium text-blue-600 dark:text-blue-400">
                ${{ preciosCalculados.precio1.toFixed(2) }} - ${{ preciosCalculados.precio4.toFixed(2) }}
              </span>
            </div>
          </div>
        </div>

        <!-- Debug: Desglose de Costos (collapsible, collapsed by default) -->
         <div v-if="false">
           <details class="bg-orange-50 dark:bg-orange-900/20 rounded-lg shadow-sm border-2 border-orange-300 dark:border-orange-700">
             <summary class="cursor-pointer p-4 font-semibold text-orange-900 dark:text-orange-200 text-sm hover:bg-orange-100 dark:hover:bg-orange-900/30 rounded-lg transition-colors flex items-center justify-between">
               <span class="flex items-center gap-2">
                 <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                   <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                 </svg>
                 DEBUG: Desglose de Costos Calculados
               </span>
               <svg class="w-4 h-4 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                 <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
               </svg>
             </summary>
   
             <div class="p-4 border-t border-orange-200 dark:border-orange-700">
             <!-- Áreas calculadas -->
             <div class="bg-white dark:bg-gray-800 rounded p-2 mb-3 space-y-1">
               <div class="flex justify-between text-xs">
                 <span class="text-blue-600 dark:text-blue-400 font-medium">Área Papel:</span>
                 <span class="font-mono text-blue-800 dark:text-blue-300">{{ areaPapelCalculada }} m²</span>
               </div>
               <div class="flex justify-between text-xs">
                 <span class="text-green-600 dark:text-green-400 font-medium">Área Corrugado:</span>
                 <span class="font-mono text-green-800 dark:text-green-300">{{ areaCorrugadoCalculada }} m²</span>
               </div>
             </div>
   
             <div class="space-y-1 text-xs">
               <!-- SIEMPRE usar seccionesLocales (memoria) -->
               <div v-for="(seccion, sIdx) in seccionesLocales" :key="sIdx" class="mb-3">
                 <div class="font-semibold text-orange-800 dark:text-orange-300 mb-1">
                   {{ seccion.seccion?.nombreSeccion }}
                 </div>
                 <div v-for="(comp, cIdx) in seccion.componentes" :key="cIdx" class="ml-2 space-y-1">
                   <div class="font-medium text-orange-700 dark:text-orange-400 flex justify-between">
                     <span>└ {{ comp.nombreMostrar || comp.catalogo?.nombreCatalogo }}</span>
                     <span v-if="comp.costoCalculado" class="font-mono text-orange-900 dark:text-orange-200">
                       = ${{ Number(comp.costoCalculado).toFixed(4) }}
                     </span>
                   </div>
                   <template v-if="comp.registro && comp.registro.valores_campo">
                     <div v-for="valor in comp.registro.valores_campo.filter(v => v.campo?.esMonto)" :key="valor.valorId" class="ml-4">
                       <div class="flex justify-between items-center">
                         <span class="text-orange-600 dark:text-orange-500">
                           {{ valor.campo?.nombreCampo }}
                           <span v-if="valor.campo?.esCalculado && valor.campo?.tipoCalculo" class="text-xs px-1 rounded"
                             :class="{
                               'bg-blue-200 dark:bg-blue-800': valor.campo.tipoCalculo === 'area_papel',
                               'bg-green-200 dark:bg-green-800': valor.campo.tipoCalculo === 'area_corrugado',
                               'bg-gray-200 dark:bg-gray-700': valor.campo.tipoCalculo === 'valor_directo'
                             }">
                             {{ valor.campo.tipoCalculo === 'area_papel' ? '×📄' : valor.campo.tipoCalculo === 'area_corrugado' ? '×📦' : '=' }}
                           </span>:
                         </span>
                         <span class="font-mono text-orange-800 dark:text-orange-300">${{ valor.valorNumerico }}</span>
                       </div>
                     </div>
                   </template>
                   <div v-else class="ml-4 text-gray-500 italic text-xs">Sin registro seleccionado</div>
                 </div>
               </div>
   
               <div class="border-t-2 border-orange-300 dark:border-orange-700 pt-2 mt-2 flex justify-between font-bold text-orange-900 dark:text-orange-200">
                 <span>TOTAL:</span>
                 <span>${{ costoTotalLocal.toFixed(2) }}</span>
               </div>
             </div>
             </div>
           </details>
         </div>
      </div>
      <!-- Fin Panel Lateral -->
    </div>
    <!-- Fin Layout 2 columnas -->

    <!-- Modal para agregar sección -->
    <div v-if="showSeccionModal" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] flex flex-col">
        <div class="p-6 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center">
          <h3 class="text-lg font-semibold text-gray-900 dark:text-white">
            Agregar Sección al Prototipo
          </h3>
          <button @click="showSeccionModal = false" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-300">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
            </svg>
          </button>
        </div>

        <div class="p-6 overflow-y-auto flex-1">
          <div v-if="seccionesDisponibles.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
            Todas las secciones ya han sido agregadas
          </div>
          <div v-else class="space-y-3">
            <div
              v-for="seccion in seccionesDisponibles"
              :key="seccion.seccionId"
              class="flex items-center justify-between p-4 border border-gray-200 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition"
            >
              <div class="flex-1">
                <div class="text-sm font-medium text-gray-900 dark:text-white">
                  {{ seccion.nombreSeccion }}
                </div>
                <div class="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  {{ seccion.descripcion || 'Sin descripción' }}
                </div>
                <div class="text-xs text-gray-600 dark:text-gray-400 mt-1">
                  <span class="inline-flex items-center">
                    <svg class="w-3 h-3 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"/>
                    </svg>
                    {{ getCatalogosCount(seccion.seccionId) }} catálogos
                  </span>
                </div>
              </div>
              <button
                @click="agregarSeccionIndividual(seccion.seccionId)"
                :disabled="loading"
                class="px-4 py-2 bg-green-600 text-white rounded-lg text-sm hover:bg-green-700 disabled:opacity-50 transition flex items-center gap-2"
              >
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                </svg>
                {{ loading ? 'Agregando...' : 'Agregar' }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Selección de Contacto -->
  <div v-if="showModalContacto" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-bold text-gray-900 dark:text-white">Seleccionar Contacto</h3>
        <button @click="cerrarModalContacto" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Búsqueda -->
      <div class="mb-4">
        <input
          v-model="busquedaContacto"
          type="text"
          placeholder="Buscar por nombre, razón social, RFC o email..."
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white"
        />
      </div>

      <!-- Lista de contactos -->
      <div class="space-y-2 max-h-96 overflow-y-auto">
        <div
          v-for="contacto in contactosFiltrados"
          :key="contacto.id"
          @click="seleccionarContacto(contacto)"
          class="p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-violet-50 dark:hover:bg-gray-700 cursor-pointer transition"
        >
          <div class="flex justify-between items-start">
            <div>
              <div class="font-semibold text-gray-900 dark:text-white">{{ contacto.nombre_completo }}</div>
              <div class="text-sm text-gray-600 dark:text-gray-400">
                <span class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium mr-2"
                  :class="contacto.tipo_contacto === 'mixto' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' : (contacto.tipo_contacto === 'fiscal' ? 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300' : 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300')">
                  {{ contacto.tipo_contacto === 'mixto' ? 'Mixto' : (contacto.tipo_contacto === 'fiscal' ? 'Fiscal' : 'Personal') }}
                </span>
                {{ contacto.email }}
                <span v-if="contacto.rfc" class="ml-2">RFC: {{ contacto.rfc }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="contactosFiltrados.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
          No se encontraron contactos
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de Selección de Fracción -->
  <div v-if="showModalFraccion" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-white dark:bg-gray-800 rounded-lg p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-xl font-bold text-gray-900 dark:text-white">Seleccionar Fracción Arancelaria</h3>
        <button @click="cerrarModalFraccion" class="text-gray-400 hover:text-gray-600 dark:hover:text-gray-200">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
          </svg>
        </button>
      </div>

      <!-- Búsqueda -->
      <div class="mb-4">
        <input
          v-model="busquedaFraccion"
          type="text"
          placeholder="Buscar por código o descripción..."
          class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:outline-none focus:ring-violet-500 focus:border-violet-500 dark:bg-gray-700 dark:text-white"
        />
      </div>

      <!-- Lista de fracciones -->
      <div class="space-y-2 max-h-96 overflow-y-auto">
        <div
          v-for="fraccion in fraccionesFiltradas"
          :key="fraccion.id"
          @click="seleccionarFraccion(fraccion)"
          class="p-3 border border-gray-200 dark:border-gray-700 rounded-lg hover:bg-violet-50 dark:hover:bg-gray-700 cursor-pointer transition"
        >
          <div class="font-semibold text-gray-900 dark:text-white">{{ fraccion.codigo }}</div>
          <div class="text-sm text-gray-600 dark:text-gray-400">{{ fraccion.descripcion }}</div>
        </div>
        <div v-if="fraccionesFiltradas.length === 0" class="text-center py-8 text-gray-500 dark:text-gray-400">
          No se encontraron fracciones
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useCatalogosNew } from '../../composables/useCatalogosNew'
import { useUserStore } from '@/stores/user'
import { useHttp } from '@/composables/useHttp.js'
import SearchableSelect from '@/components/SearchableSelect.vue'
import Swal from 'sweetalert2'

const route = useRoute()
const router = useRouter()
const userStore = useUserStore()

const {
  loading,
  secciones,
  catalogos,
  fetchSecciones,
  fetchCatalogos,
  fetchRegistrosByCatalogo,
  fetchPrototipo,
  createPrototipo,
  updatePrototipo,
  addSeccionToPrototipo,
  deleteSeccionPrototipo,
  updateComponentePrototipo,
  deleteComponentePrototipo,
  obtenerCatalogosDeSeccion,
  sincronizarSeccionPrototipo
} = useCatalogosNew()

const isEditing = computed(() => !!route.params.id)
const prototipo = ref(null)
const prototipoOriginal = ref(null) // Guardamos el original para comparar cambios
const showSeccionModal = ref(false)
const registrosPorCatalogo = ref({})
const catalogosPorSeccion = ref({}) // Almacena el conteo de catálogos por sección
const seccionesLocales = ref([]) // Secciones en memoria (tanto para nuevo como para edición)

// Catálogos de contactos y fracciones
const { get, data } = useHttp()
const contactos = ref([])
const fracciones = ref([])
const showModalContacto = ref(false)
const showModalFraccion = ref(false)
const busquedaContacto = ref('')
const busquedaFraccion = ref('')

// Computed para secciones que se muestran (SIEMPRE locales en memoria)
const seccionesActuales = computed(() => {
  return seccionesLocales.value
})

// Computed para obtener secciones disponibles (no agregadas aún)
const seccionesDisponibles = computed(() => {
  const seccionesAgregadas = seccionesActuales.value.map(ps => ps.seccionId || ps.seccion_id)
  return secciones.value.filter(s => !seccionesAgregadas.includes(s.seccionId))
})

const formData = ref({
  folio: '',
  contacto_id: '',
  cliente: '',
  proyecto: '',
  fraccion_id: '',
  fraccion: '',
  descripcion: '',
  fecha: new Date().toISOString().split('T')[0],
  cantidad: 1, // Siempre 1 en el prototipo
  poses: 1,
  estado: 'Borrador',
  largo: 49.6,
  ancho: 49.6,
  alto: 96,
  anchoPapel: 65,
  largoPapel: 100,
  anchoCorrugado: 100,
  largoCorrugado: 65,
  cantidadPorPaquete: 10,
  paquetesPorTarima: 50
})

// ========== Computadas para Áreas ==========

// Área Papel (m²) = ROUNDUP((Ancho Papel/100)*(Largo Papel/100),4)
const areaPapelCalculada = computed(() => {
  const ancho = parseFloat(formData.value.anchoPapel) || 0
  const largo = parseFloat(formData.value.largoPapel) || 0
  // console.log("areaPapelCalculada: ", ancho, " - ", largo);
  if (ancho === 0 || largo === 0) return '0.0000'

  const area = (ancho / 100) * (largo / 100)
  return (Math.ceil(area * 10000) / 10000).toFixed(4) // ROUNDUP con 4 decimales
})

// Área Corrugado (m²) = ROUNDUP((Ancho Corrugado/100)*(Largo Corrugado/100),4)
const areaCorrugadoCalculada = computed(() => {
  const ancho = parseFloat(formData.value.anchoCorrugado) || 0
  const largo = parseFloat(formData.value.largoCorrugado) || 0

  if (ancho === 0 || largo === 0) return '0.0000'

  const area = (ancho / 100) * (largo / 100)
  return (Math.ceil(area * 10000) / 10000).toFixed(4) // ROUNDUP con 4 decimales
})

// Folio generado automáticamente: Cliente-Proyecto-Fracción
const folioGenerado = computed(() => {
  // Obtener el nombre del contacto seleccionado
  const contactoSeleccionado = contactos.value.find(c => c.id === formData.value.contacto_id)
  const cliente = contactoSeleccionado ? contactoSeleccionado.id : (formData.value.contacto_id?.trim() || '')

  const proyecto = formData.value.proyecto?.trim() || ''

  // Obtener el código de la fracción seleccionada
  const fraccionSeleccionada = fracciones.value.find(f => f.id === formData.value.fraccion_id)
  const fraccion = fraccionSeleccionada ? fraccionSeleccionada.codigo : (formData.value.fraccion?.trim() || '')

  if (!cliente && !proyecto && !fraccion) return ''

  return [cliente, proyecto, fraccion].filter(Boolean).join('-')
})

// Nombre del contacto seleccionado para mostrar en el input
const contactoSeleccionadoNombre = computed(() => {
  const contacto = contactos.value.find(c => c.id === formData.value.contacto_id)
  if (!contacto) return ''
  const tipoLabel = contacto.tipo_contacto === 'mixto' ? '(Mixto)' : (contacto.tipo_contacto === 'fiscal' ? '(Fiscal)' : '(Personal)')
  return `${contacto.nombre_completo} ${tipoLabel}`
})

// Nombre de la fracción seleccionada para mostrar en el input
const fraccionSeleccionadaNombre = computed(() => {
  const fraccion = fracciones.value.find(f => f.id === formData.value.fraccion_id)
  if (!fraccion) return ''
  return `${fraccion.codigo} - ${fraccion.descripcion}`
})

// Contactos filtrados por búsqueda
const contactosFiltrados = computed(() => {
  if (!busquedaContacto.value.trim()) return contactos.value

  const termino = busquedaContacto.value.toLowerCase().trim()
  return contactos.value.filter(c =>
    c.nombre_completo.toLowerCase().includes(termino) ||
    c.email?.toLowerCase().includes(termino) ||
    c.rfc?.toLowerCase().includes(termino) ||
    c.razon_social?.toLowerCase().includes(termino)
  )
})

// Fracciones filtradas por búsqueda
const fraccionesFiltradas = computed(() => {
  if (!busquedaFraccion.value.trim()) return fracciones.value

  const termino = busquedaFraccion.value.toLowerCase().trim()
  return fracciones.value.filter(f =>
    f.codigo.toLowerCase().includes(termino) ||
    f.descripcion.toLowerCase().includes(termino)
  )
})

// ========== Computadas para Costos y Precios ==========

// Porcentajes del negocio seleccionado
const porcentajesNegocio = computed(() => {
  if (!userStore.negocioSeleccionado) {
    return {
      porcentaje1: 25.00,
      porcentaje2: 35.00,
      porcentaje3: 50.00,
      porcentaje4: 75.00
    }
  }
  return {
    porcentaje1: userStore.negocioSeleccionado.porcentaje1 || 25.00,
    porcentaje2: userStore.negocioSeleccionado.porcentaje2 || 35.00,
    porcentaje3: userStore.negocioSeleccionado.porcentaje3 || 50.00,
    porcentaje4: userStore.negocioSeleccionado.porcentaje4 || 75.00
  }
})

// Cálculo de costos clasificados por tipoMonto (desde memoria local) CON DETALLE
const costosClasificadosLocal = computed(() => {
  // console.log('🔄 [costosClasificadosLocal] Computed ejecutándose...')

  let sumaCostosAfectadosPorPoses = 0
  let sumaCostosAdicionales = 0
  let sumaCostosAjuste = 0
  let costoHerramentales = 0

  // Arrays para almacenar el detalle de cada tipo
  const detalleAfectadosPorPoses = []
  const detalleAdicionales = []
  const detalleAjuste = []
  const detalleHerramentales = []

  // console.log(`📦 Secciones locales: ${seccionesLocales.value.length}`)

  for (const seccion of seccionesLocales.value) {
    // console.log(`  📁 Sección: ${seccion.seccion?.nombreSeccion}, Componentes: ${seccion.componentes?.length || 0}`)

    for (const componente of seccion.componentes || []) {
      if (!componente.registro?.valores_campo) {
        // console.log(`    ⚠️  Componente ${componente.catalogo?.nombreCatalogo}: SIN registro o valores_campo`)
        continue
      }

      // console.log(`    ✅ Componente ${componente.catalogo?.nombreCatalogo}: ${componente.registro.valores_campo.length} valores`)

      for (const valor of componente.registro.valores_campo) {
        if (!valor.campo?.esMonto || !valor.valorNumerico) {
          // console.log(`      ⏩ Campo ${valor.campo?.nombreCampo}: NO es monto o sin valor`)
          continue
        }

        let valorCalculado = parseFloat(valor.valorNumerico)
        const valorOriginal = valorCalculado
        const tipoMonto = valor.campo.tipoMonto

        // console.log(`      💰 Campo: ${valor.campo.nombreCampo}, Valor Original: $${valorCalculado.toFixed(4)}, TipoMonto: ${tipoMonto}`)

        // Aplicar cálculos si el campo es calculado (igual que en actualizarComponente)
        let tipoCalculoAplicado = 'valor_directo'
        if (valor.campo?.esCalculado && valor.campo?.tipoCalculo) {
          const areaPapel = parseFloat(areaPapelCalculada.value) || 0
          const areaCorrugado = parseFloat(areaCorrugadoCalculada.value) || 0
          const cantidadPaquete = parseFloat(formData.value.cantidadPorPaquete) || 1
          const paquetesTarima = parseFloat(formData.value.paquetesPorTarima) || 1

          tipoCalculoAplicado = valor.campo.tipoCalculo
          const valorAntes = valorCalculado
          switch (tipoCalculoAplicado) {
            case 'area_papel':
              valorCalculado = valorCalculado * areaPapel
              // console.log(`        🧮 ${tipoCalculoAplicado}: $${valorAntes.toFixed(4)} × ${areaPapel} = $${valorCalculado.toFixed(4)}`)
              break
            case 'area_corrugado':
              valorCalculado = valorCalculado * areaCorrugado
              // console.log(`        🧮 ${tipoCalculoAplicado}: $${valorAntes.toFixed(4)} × ${areaCorrugado} = $${valorCalculado.toFixed(4)}`)
              break
            case 'division_cantidad_paquete':
              valorCalculado = valorCalculado / cantidadPaquete
              // console.log(`        🧮 ${tipoCalculoAplicado}: $${valorAntes.toFixed(4)} ÷ ${cantidadPaquete} = $${valorCalculado.toFixed(4)}`)
              break
            case 'division_cantidad_tarima':
              valorCalculado = valorCalculado / (cantidadPaquete * paquetesTarima)
              // console.log(`        🧮 ${tipoCalculoAplicado}: $${valorAntes.toFixed(4)} ÷ (${cantidadPaquete} × ${paquetesTarima}) = $${valorCalculado.toFixed(4)}`)
              break
            case 'division_envio':
              const tarXUnidadValor = componente.registro.valores_campo.find(
                v => v.campo?.nombreCampo === 'Tar x Unidad'
              )
              const tarXUnidad = tarXUnidadValor ? parseFloat(tarXUnidadValor.valorNumerico) || 1 : 1
              valorCalculado = valorCalculado / (cantidadPaquete * paquetesTarima * tarXUnidad)
              // console.log(`        🧮 ${tipoCalculoAplicado}: $${valorAntes.toFixed(4)} ÷ (${cantidadPaquete} × ${paquetesTarima} × ${tarXUnidad}) = $${valorCalculado.toFixed(4)}`)
              break
            default: //valor_directo
              // console.log(`        ℹ️  Directo: ${tipoCalculoAplicado}`)
          }
        }

        // Clasificar según tipoMonto (usando el valor YA calculado)
        const detalleItem = {
          catalogo: componente.catalogo?.nombreCatalogo || 'Sin catálogo',
          campo: valor.campo.nombreCampo,
          valor: valorCalculado,
          valorOriginal: valorOriginal,
          tipoCalculo: tipoCalculoAplicado
        }

        if (tipoMonto === 'referencia') {
          // Solo referencia, no suma al costo
          // console.log(`        ℹ️  Solo Referencia: $${valorCalculado.toFixed(4)} (no suma al costo)`)
        } else if (tipoMonto === 'afectado_por_poses') {
          sumaCostosAfectadosPorPoses += valorCalculado
          detalleAfectadosPorPoses.push(detalleItem)
          // console.log(`        ➕ Sumando a Base: $${valorCalculado.toFixed(4)} (Total: $${sumaCostosAfectadosPorPoses.toFixed(4)})`)
        } else if (tipoMonto === 'costo_adicional') {
          sumaCostosAdicionales += valorCalculado
          detalleAdicionales.push(detalleItem)
          // console.log(`        ➕ Sumando a Adicional: $${valorCalculado.toFixed(4)} (Total: $${sumaCostosAdicionales.toFixed(4)})`)
        } else if (tipoMonto === 'costo_ajuste') {
          sumaCostosAjuste += valorCalculado
          detalleAjuste.push(detalleItem)
          // console.log(`        ➕ Sumando a Ajuste: $${valorCalculado.toFixed(4)} (Total: $${sumaCostosAjuste.toFixed(4)})`)
        } else if (tipoMonto === 'herramental') {
          costoHerramentales += valorCalculado
          detalleHerramentales.push(detalleItem)
          // console.log(`        ➕ Sumando a Herramental: $${valorCalculado.toFixed(4)} (Total: $${costoHerramentales.toFixed(4)})`)
        } else {
          // console.log(`        ⚠️  TipoMonto desconocido: ${tipoMonto}`)
        }
      }
    }
  }

  // console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
  // console.log('📊 TOTALES CALCULADOS:')
  // console.log(`   Base (Poses):     $${sumaCostosAfectadosPorPoses.toFixed(4)}`)
  // console.log(`   Adicionales:      $${sumaCostosAdicionales.toFixed(4)}`)
  // console.log(`   Ajuste:           $${sumaCostosAjuste.toFixed(4)}`)
  // console.log(`   Herramentales:    $${costoHerramentales.toFixed(4)}`)
  // console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')

  return {
    sumaCostosAfectadosPorPoses,
    sumaCostosAdicionales,
    sumaCostosAjuste,
    costoHerramentales,
    detalleAfectadosPorPoses,
    detalleAdicionales,
    detalleAjuste,
    detalleHerramentales
  }
})

// Cálculo del costo unitario local (desde memoria local)
const costoUnitarioLocal = computed(() => {
  const poses = parseInt(formData.value.poses) || 1
  const basesPorPoses = costosClasificadosLocal.value.sumaCostosAfectadosPorPoses / poses
  return basesPorPoses + costosClasificadosLocal.value.sumaCostosAdicionales
})

// Cálculo del costo de ajuste unitario local (desde memoria local)
const costoAjusteLocal = computed(() => {
  const cantidad = parseInt(formData.value.cantidad) || 1
  return costosClasificadosLocal.value.sumaCostosAjuste / cantidad
})

// Cálculo del costo total local (SIEMPRE desde memoria local)
const costoTotalLocal = computed(() => {
  let total = 0

  // SIEMPRE calcular desde las secciones locales en memoria
  // Usar el costoCalculado de cada componente (ya incluye multiplicación por áreas)
  for (const seccion of seccionesLocales.value) {
    for (const componente of seccion.componentes || []) {
      if (componente.costoCalculado) {
        total += parseFloat(componente.costoCalculado)
      }
    }
  }

  return total
})

// Precios calculados basados en el costo total y los porcentajes
const preciosCalculados = computed(() => {
  const costoTotal = costoUnitarioLocal.value + costoAjusteLocal.value
  const porcentajes = porcentajesNegocio.value

  return {
    precio1: costoTotal / (1 - porcentajes.porcentaje1 / 100) / 0.975,
    precio2: costoTotal / (1 - porcentajes.porcentaje2 / 100) / 0.975,
    precio3: costoTotal / (1 - porcentajes.porcentaje3 / 100) / 0.975,
    precio4: costoTotal / (1 - porcentajes.porcentaje4 / 100) / 0.975
  }
})

// ========== Fin Computadas ==========

// Cargar contactos y fracciones
const cargarContactos = async () => {
  try {
    await get('/contactos?per_page=1000&estatus=activo')
    contactos.value = data.value.data
  } catch (error) {
    console.error('Error al cargar contactos:', error)
  }
}

const cargarFracciones = async () => {
  try {
    await get('/fracciones?per_page=1000&estatus=activo')
    fracciones.value = data.value.data
  } catch (error) {
    console.error('Error al cargar fracciones:', error)
  }
}

// Funciones para modales de contacto
const abrirModalContacto = () => {
  busquedaContacto.value = ''
  showModalContacto.value = true
}

const cerrarModalContacto = () => {
  showModalContacto.value = false
  busquedaContacto.value = ''
}

const seleccionarContacto = (contacto) => {
  formData.value.contacto_id = contacto.id
  formData.value.cliente = contacto.nombre_completo
  cerrarModalContacto()
}

// Funciones para modales de fracción
const abrirModalFraccion = () => {
  busquedaFraccion.value = ''
  showModalFraccion.value = true
}

const cerrarModalFraccion = () => {
  showModalFraccion.value = false
  busquedaFraccion.value = ''
}

const seleccionarFraccion = (fraccion) => {
  formData.value.fraccion_id = fraccion.id
  formData.value.fraccion = fraccion.codigo
  cerrarModalFraccion()
}

onMounted(async () => {
  console.log('🚀 INICIANDO onMounted...')

  await Promise.all([
    fetchSecciones(),
    fetchCatalogos(),
    cargarContactos(),
    cargarFracciones()
  ])

  console.log(`✅ Datos cargados - Secciones: ${secciones.value.length}, Catálogos: ${catalogos.value.length}, Contactos: ${contactos.value.length}, Fracciones: ${fracciones.value.length}`)

  if (catalogos.value.length > 0) {
    const relaciones = catalogos.value[0].seccion_catalogos || catalogos.value[0].seccionCatalogos
    console.log('📦 Primer catálogo:', {
      id: catalogos.value[0].catalogoId,
      nombre: catalogos.value[0].nombreCatalogo,
      tieneSeccionCatalogos: !!relaciones,
      seccionCatalogosCount: relaciones?.length || 0,
      claveUsada: catalogos.value[0].seccion_catalogos ? 'seccion_catalogos' : 'seccionCatalogos'
    })
  }

  // Cargar catálogos por sección
  await cargarCatalogosPorSeccion()

  // Cargar registros de todos los catálogos
  await cargarRegistrosDeCatalogos()

  if (isEditing.value) {
    console.log('📝 Modo EDICIÓN - cargando prototipo...')
    await cargarPrototipo()
  } else {
    // Al crear un prototipo nuevo, agregar secciones marcadas como "incluir por defecto"
    console.log('🆕 Modo CREACIÓN - cargando secciones por defecto...')
    await cargarSeccionesPorDefecto()
  }
})

const cargarSeccionesPorDefecto = async () => {
  try {
    // Filtrar secciones que tienen incluirPorDefecto = true
    const seccionesPorDefecto = secciones.value.filter(s => s.incluirPorDefecto === true)

    console.log('📋 Cargando secciones por defecto:', seccionesPorDefecto.length)

    for (const seccion of seccionesPorDefecto) {
      // Obtener catálogos de la sección
      const catalogosDeSeccion = await obtenerCatalogosDeSeccion(seccion.seccionId)

      // Crear componentes para cada catálogo de la sección
      const componentes = catalogosDeSeccion.map(sc => ({
        catalogoId: sc.catalogo.catalogoId,
        catalogo: sc.catalogo,
        nombreMostrar: sc.nombreMostrar,
        registroId: null,
        registro: null,
        costoCalculado: null,
        notas: ''
      }))

      // Agregar la sección a seccionesLocales
      seccionesLocales.value.push({
        seccionId: seccion.seccionId,
        seccion_id: seccion.seccionId,
        seccion: seccion,
        orden: seccion.orden,
        componentes: componentes
      })
    }

    console.log('✅ Secciones por defecto cargadas:', seccionesLocales.value.length)
  } catch (error) {
    console.error('Error al cargar secciones por defecto:', error)
  }
}

const cargarCatalogosPorSeccion = async () => {
  for (const seccion of secciones.value) {
    try {
      const catalogosDeSeccion = await obtenerCatalogosDeSeccion(seccion.seccionId)
      catalogosPorSeccion.value[seccion.seccionId] = catalogosDeSeccion.length
    } catch (error) {
      catalogosPorSeccion.value[seccion.seccionId] = 0
    }
  }
}

const cargarPrototipo = async () => {
  try {
    prototipoOriginal.value = await fetchPrototipo(route.params.id)
    prototipo.value = prototipoOriginal.value

    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
    console.log('📦 PROTOTIPO CARGADO DE LA BASE DE DATOS')
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━')
    console.log('Folio:', prototipo.value.folio)
    console.log('Cliente:', prototipo.value.cliente)

    // Verificar qué nombre de campo tiene
    const seccionesCargadas = prototipo.value.prototipo_secciones || prototipo.value.prototipoSecciones
    console.log('\n📋 SECCIONES GUARDADAS EN BD:', seccionesCargadas ? seccionesCargadas.length : 0)
    console.log('   Nombre del campo usado:', prototipo.value.prototipo_secciones ? 'prototipo_secciones' : 'prototipoSecciones')

    if (seccionesCargadas && seccionesCargadas.length > 0) {
      seccionesCargadas.forEach((seccion, idx) => {
        console.log(`\n   ${idx + 1}. Sección: ${seccion.seccion?.nombreSeccion || 'SIN NOMBRE'} (ID: ${seccion.seccionId})`)
        console.log(`      prototipoSeccionId: ${seccion.prototipoSeccionId}`)
        console.log(`      Componentes/Catálogos: ${seccion.componentes?.length || 0}`)

        if (seccion.componentes && seccion.componentes.length > 0) {
          seccion.componentes.forEach((comp, cIdx) => {
            console.log(`         ${cIdx + 1}. Catálogo ID ${comp.catalogoId}: ${comp.catalogo?.nombreCatalogo || 'SIN NOMBRE'}`)
            console.log(`            - prototipoComponenteId: ${comp.prototipoComponenteId}`)
            console.log(`            - registroId: ${comp.registroId || 'NULL (sin selección)'}`)
            if (comp.registro) {
              console.log(`            - registro nombre: ${comp.registro.nombreRegistro || 'SIN NOMBRE'}`)
            }
          })
        }
      })
    } else {
      console.log('   ⚠️ NO HAY SECCIONES GUARDADAS')
    }
    console.log('━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━\n')

    formData.value = {
      folio: prototipo.value.folio,
      cliente: prototipo.value.cliente,
      proyecto: prototipo.value.proyecto,
      fraccion: prototipo.value.fraccion,
      descripcion: prototipo.value.descripcion || '',
      fecha: prototipo.value.fecha,
      cantidad: prototipo.value.cantidad,
      poses: prototipo.value.poses,
      estado: prototipo.value.estado,
      largo: prototipo.value.largo || 0,
      ancho: prototipo.value.ancho || 0,
      alto: prototipo.value.alto || 0,
      anchoPapel: prototipo.value.anchoPapel || 0,
      largoPapel: prototipo.value.largoPapel || 0,
      anchoCorrugado: prototipo.value.anchoCorrugado || 0,
      largoCorrugado: prototipo.value.largoCorrugado || 0,
      cantidadPorPaquete: prototipo.value.cantidadPorPaquete || 1,
      paquetesPorTarima: prototipo.value.paquetesPorTarima || 1
    }

    // ✅ SIEMPRE cargar TODAS las secciones por defecto con TODOS sus catálogos
    // No importa si el prototipo tiene selecciones guardadas o no
    console.log('🔍 DEBUG cargarPrototipo:')
    console.log('  - secciones.value.length:', secciones.value.length)
    console.log('  - catalogos.value.length:', catalogos.value.length)

    if (catalogos.value.length > 0) {
      console.log('  - Ejemplo de catálogo[0]:', JSON.stringify({
        catalogoId: catalogos.value[0].catalogoId,
        nombreCatalogo: catalogos.value[0].nombreCatalogo,
        seccionCatalogos: catalogos.value[0].seccionCatalogos
      }, null, 2))
    }

    const seccionesPorDefecto = secciones.value.filter(s => s.incluirPorDefecto === true)
    console.log('  - seccionesPorDefecto.length:', seccionesPorDefecto.length)

    // Crear mapa de selecciones guardadas para acceso rápido
    const seleccionesGuardadas = new Map()
    // Soportar tanto snake_case como camelCase
    const seccionesGuardadas = prototipo.value.prototipo_secciones || prototipo.value.prototipoSecciones || []

    console.log('🔍 DEBUG: seccionesGuardadas:', seccionesGuardadas.length)
    if (seccionesGuardadas.length > 0) {
      console.log('  - Primera sección:', JSON.stringify(seccionesGuardadas[0], null, 2))
    }

    for (const seccionGuardada of seccionesGuardadas) {
      for (const componenteGuardado of seccionGuardada.componentes || []) {
        if (componenteGuardado.registroId) {
          const key = `${seccionGuardada.seccionId}-${componenteGuardado.catalogoId}`
          console.log(`  ✓ Guardando selección: ${key} -> registroId=${componenteGuardado.registroId}`)
          seleccionesGuardadas.set(key, componenteGuardado)
        }
      }
    }

    console.log('🔍 Cargando prototipo para editar...')
    console.log(`📊 Secciones por defecto del sistema: ${seccionesPorDefecto.length}`)
    console.log(`💾 Selecciones guardadas en BD: ${seleccionesGuardadas.size}`)

    // Mapear todas las secciones disponibles
    seccionesLocales.value = seccionesPorDefecto.map((seccion, index) => {
      // Obtener TODOS los catálogos de esta sección
      console.log(`🔍 Procesando sección: ${seccion.nombreSeccion} (ID: ${seccion.seccionId})`)
      console.log(`  - Total catálogos disponibles: ${catalogos.value.length}`)

      const catalogosDeSeccion = catalogos.value.filter(cat => {
        // Laravel envía la relación en snake_case: seccion_catalogos
        const relaciones = cat.seccion_catalogos || cat.seccionCatalogos || []
        const tieneRelacion = relaciones.some(sc => sc.seccionId === seccion.seccionId)
        if (tieneRelacion) {
          console.log(`    ✓ ${cat.nombreCatalogo} pertenece a esta sección`)
        }
        return tieneRelacion
      })

      console.log(`  - Catálogos encontrados para ${seccion.nombreSeccion}: ${catalogosDeSeccion.length}`)

      // Crear componentes para todos los catálogos
      const componentes = catalogosDeSeccion.map(cat => {
        const key = `${seccion.seccionId}-${cat.catalogoId}`
        const seleccionGuardada = seleccionesGuardadas.get(key)

        if (seleccionGuardada) {
          // Si hay selección guardada, usarla
          return {
            prototipoComponenteId: null, // No usamos IDs de BD en memoria
            catalogoId: cat.catalogoId,
            catalogo: cat,
            registroId: seleccionGuardada.registroId,
            registro: seleccionGuardada.registro,
            costoCalculado: parseFloat(seleccionGuardada.costoCalculado) || 0,
            notas: seleccionGuardada.notas || ''
          }
        } else {
          // Si NO hay selección, mostrar vacío
          return {
            prototipoComponenteId: null,
            catalogoId: cat.catalogoId,
            catalogo: cat,
            registroId: null,
            registro: null,
            costoCalculado: 0,
            notas: ''
          }
        }
      })

      console.log(`  📁 ${seccion.nombreSeccion}: ${componentes.length} catálogos, ${componentes.filter(c => c.registroId).length} seleccionados`)

      return {
        prototipoSeccionId: null, // No usamos IDs de BD en memoria
        seccionId: seccion.seccionId,
        seccion_id: seccion.seccionId,
        orden: index,
        seccion: seccion,
        componentes: componentes
      }
    })

    console.log('✅ Carga completada:', seccionesLocales.value.length, 'secciones con todas sus opciones disponibles')
    console.log('  - seccionesLocales.value:', JSON.stringify(seccionesLocales.value.map(s => ({
      seccionId: s.seccionId,
      nombreSeccion: s.seccion?.nombreSeccion,
      componentesCount: s.componentes?.length
    })), null, 2))

    // Cargar registros para todos los catálogos
    await cargarRegistrosDeCatalogos()
  } catch (error) {
    console.error('Error al cargar prototipo:', error)
  }
}

const cargarRegistrosDeCatalogos = async () => {
  for (const catalogo of catalogos.value) {
    const regs = await fetchRegistrosByCatalogo(catalogo.catalogoId)
    // Indexar por catalogoId en lugar de tipoComponenteId
    registrosPorCatalogo.value[catalogo.catalogoId] = regs
  }
}

const getRegistrosParaCatalogo = (catalogoId) => {
  return registrosPorCatalogo.value[catalogoId] || []
}

const guardarPrototipo = async () => {
  try {
    // Validaciones de campos requeridos
    if (!formData.value.cliente?.trim()) {
      await Swal.fire({
        icon: 'warning',
        title: 'Campo requerido',
        text: 'El campo Cliente es requerido',
        confirmButtonColor: '#7c3aed'
      })
      return
    }
    if (!formData.value.proyecto?.trim()) {
      await Swal.fire({
        icon: 'warning',
        title: 'Campo requerido',
        text: 'El campo Proyecto es requerido',
        confirmButtonColor: '#7c3aed'
      })
      return
    }
    if (!formData.value.fraccion?.trim()) {
      await Swal.fire({
        icon: 'warning',
        title: 'Campo requerido',
        text: 'El campo Fracción es requerido',
        confirmButtonColor: '#7c3aed'
      })
      return
    }
    if (!formData.value.fecha) {
      await Swal.fire({
        icon: 'warning',
        title: 'Campo requerido',
        text: 'El campo Fecha es requerido',
        confirmButtonColor: '#7c3aed'
      })
      return
    }

    // Agregar áreas calculadas y folio generado al formData
    const dataToSave = {
      ...formData.value,
      folio: folioGenerado.value, // Folio auto-generado
      areaM2Papel: parseFloat(areaPapelCalculada.value),
      areaM2Corrugado: parseFloat(areaCorrugadoCalculada.value)
    }

    if (isEditing.value) {
      // 1. Actualizar los datos básicos del prototipo
      await updatePrototipo(route.params.id, dataToSave)

      // 2. Comparación inteligente: crear/actualizar/eliminar según diferencias
      // Soportar tanto snake_case como camelCase
      const seccionesOriginales = prototipoOriginal.value?.prototipo_secciones || prototipoOriginal.value?.prototipoSecciones || []
      // console.log('📊 Análisis de guardado:')
      // console.log(`  - Secciones en BD (originales): ${seccionesOriginales.length}`)
      // console.log(`  - Secciones locales: ${seccionesLocales.value.length}`)

      // Crear un mapa de secciones originales para acceso rápido
      const seccionesOriginalesMap = new Map()
      for (const seccionOriginal of seccionesOriginales) {
        // console.log(`  - Sección BD: ${seccionOriginal.seccion?.nombreSeccion} con ${seccionOriginal.componentes?.length || 0} componentes`)
        seccionesOriginalesMap.set(seccionOriginal.seccionId, seccionOriginal)
      }

      // Procesar cada sección local
      for (const seccionLocal of seccionesLocales.value) {
        const componentesConSeleccion = seccionLocal.componentes.filter(c => c.registroId)
        const seccionOriginal = seccionesOriginalesMap.get(seccionLocal.seccionId)

        // console.log(`\n🔍 Procesando sección: ${seccionLocal.seccion?.nombreSeccion}`)
        // console.log(`  - Componentes locales con selección: ${componentesConSeleccion.length}`)
        // console.log(`  - Existe en BD: ${!!seccionOriginal}`)

        if (componentesConSeleccion.length > 0) {
          // Esta sección tiene selecciones
          if (seccionOriginal) {
            // La sección YA EXISTE en BD - procesar componentes
            // console.log(`  ✓ Sección existe en BD, procesando componentes...`)
            const componentesOriginalesMap = new Map()
            for (const compOriginal of seccionOriginal.componentes || []) {
              // console.log(`    - Componente BD: catalogoId=${compOriginal.catalogoId}, registroId=${compOriginal.registroId}`)
              componentesOriginalesMap.set(compOriginal.catalogoId, compOriginal)
            }

            // Procesar cada componente con selección
            for (const compLocal of componentesConSeleccion) {
              const compOriginal = componentesOriginalesMap.get(compLocal.catalogoId)
              // console.log(`    • Procesando componente local: catalogoId=${compLocal.catalogoId}, registroId=${compLocal.registroId}`)

              if (compOriginal) {
                // ACTUALIZAR: El componente existe, actualizar su registroId
                if (compOriginal.registroId !== compLocal.registroId) {
                  await updateComponentePrototipo(compOriginal.prototipoComponenteId, {
                    registroId: compLocal.registroId
                  })
                }
                // Marcar como procesado
                componentesOriginalesMap.delete(compLocal.catalogoId)
              } else {
                // CREAR: El componente no existe, necesitamos crearlo
                // Buscar si existe algún componente de esta sección/catálogo sin registroId
                const compSinSeleccion = seccionOriginal.componentes?.find(
                  c => c.catalogoId === compLocal.catalogoId && !c.registroId
                )

                if (compSinSeleccion) {
                  // Actualizar el existente
                  await updateComponentePrototipo(compSinSeleccion.prototipoComponenteId, {
                    registroId: compLocal.registroId
                  })
                } else {
                  // No existe, se creará al sincronizar (caso raro)
                  // console.warn(`Componente ${compLocal.catalogoId} no encontrado en BD`)
                }
              }
            }

            // ELIMINAR: Componentes que quedaron sin procesar y tenían registroId
            console.log(`    🗑️ Eliminando componentes sin selección (quedaron ${componentesOriginalesMap.size} sin procesar)`)
            for (const [catalogoId, compOriginal] of componentesOriginalesMap) {
              console.log(`      - Componente catalogoId=${catalogoId}, registroId=${compOriginal.registroId}`)
              if (compOriginal.registroId) {
                console.log(`      ❌ ELIMINAR: Tenía registroId pero ya no está seleccionado`)
                await deleteComponentePrototipo(compOriginal.prototipoComponenteId)
              } else {
                console.log(`      ⏭️ SKIP: No tiene registroId, eliminar de todas formas`)
                await deleteComponentePrototipo(compOriginal.prototipoComponenteId)
              }
            }

            // Marcar sección como procesada
            seccionesOriginalesMap.delete(seccionLocal.seccionId)
          } else {
            // CREAR SECCIÓN NUEVA: La sección NO existe en BD
            const seccionCreada = await addSeccionToPrototipo(route.params.id, {
              seccionId: seccionLocal.seccionId,
              orden: seccionLocal.orden
            })

            // Actualizar/eliminar componentes de la nueva sección
            for (const componenteCreado of seccionCreada.componentes || []) {
              const componenteLocal = componentesConSeleccion.find(
                c => c.catalogoId === componenteCreado.catalogoId
              )

              if (componenteLocal) {
                // Actualizar con la selección
                await updateComponentePrototipo(componenteCreado.prototipoComponenteId, {
                  registroId: componenteLocal.registroId
                })
              } else {
                // Eliminar si no tiene selección
                await deleteComponentePrototipo(componenteCreado.prototipoComponenteId)
              }
            }
          }
        } else {
          // Esta sección NO tiene selecciones
          if (seccionOriginal) {
            // ELIMINAR SECCIÓN: Existía pero ya no tiene selecciones
            await deleteSeccionPrototipo(seccionOriginal.prototipoSeccionId)
            seccionesOriginalesMap.delete(seccionLocal.seccionId)
          }
          // Si no existe, no hacemos nada (no crear secciones vacías)
        }
      }

      // ELIMINAR: Secciones que quedaron sin procesar (fueron eliminadas del formulario)
      for (const [seccionId, seccionOriginal] of seccionesOriginalesMap) {
        await deleteSeccionPrototipo(seccionOriginal.prototipoSeccionId)
      }

      // Recargar el prototipo actualizado para mantener prototipoOriginal sincronizado
      console.log('🔄 Recargando prototipo después de guardar...')
      await cargarPrototipo()
      console.log('✅ Recarga completada. seccionesLocales.value.length:', seccionesLocales.value.length)

      // Forzar actualización del DOM
      await nextTick()

      // SweetAlert de éxito
      await Swal.fire({
        icon: 'success',
        title: '¡Prototipo actualizado!',
        text: 'El prototipo se ha actualizado correctamente',
        confirmButtonColor: '#7c3aed'
      })
    } else {
      // Modo CREAR
      const nuevoPrototipo = await createPrototipo(dataToSave)

      // Agregar SOLO las secciones que tienen al menos un componente seleccionado
      for (const seccionLocal of seccionesLocales.value) {
        // Verificar si esta sección tiene al menos un componente con registroId
        const tieneSelecciones = seccionLocal.componentes.some(comp => comp.registroId)

        if (tieneSelecciones) {
          // Crear la sección en el prototipo
          const seccionCreada = await addSeccionToPrototipo(nuevoPrototipo.prototipoId, {
            seccionId: seccionLocal.seccionId,
            orden: seccionLocal.orden
          })

          // Actualizar SOLO los componentes que tienen registroId seleccionado
          // Y ELIMINAR los que no tienen selección
          for (const componenteCreado of seccionCreada.componentes || []) {
            const componenteLocal = seccionLocal.componentes.find(
              c => c.catalogoId === componenteCreado.catalogoId
            )

            if (componenteLocal && componenteLocal.registroId) {
              // Si tiene selección, actualizar
              await updateComponentePrototipo(componenteCreado.prototipoComponenteId, {
                registroId: componenteLocal.registroId
              })
            } else {
              // Si NO tiene selección, eliminar
              await deleteComponentePrototipo(componenteCreado.prototipoComponenteId)
            }
          }
        }
      }

      // SweetAlert de éxito
      await Swal.fire({
        icon: 'success',
        title: '¡Prototipo creado!',
        text: `El prototipo ${nuevoPrototipo.folio} se ha creado correctamente`,
        confirmButtonColor: '#7c3aed'
      })

      // Redirigir a la página de edición
      router.push(`/prototipos-new/${nuevoPrototipo.prototipoId}/editar`)
    }
  } catch (error) {
    console.error('Error al guardar prototipo:', error)

    // Detectar errores específicos
    let errorMessage = error.message || 'Ocurrió un error al guardar el prototipo'
    let errorTitle = 'Error al guardar'

    // Error de validación (422)
    if (error.response?.status === 422) {
      const errors = error.response?.data?.errors
      if (errors) {
        // Si hay errores de validación, mostrar el primero
        const firstError = Object.values(errors)[0]
        if (Array.isArray(firstError)) {
          errorMessage = firstError[0]
        }

        // Detectar error de folio duplicado
        if (errorMessage.includes('folio') && errorMessage.includes('taken')) {
          errorTitle = 'Folio duplicado'
          errorMessage = `El folio "${folioGenerado.value}" ya existe. Por favor cambia Cliente, Proyecto o Fracción.`
        }
      }
    }
    // Error 500 del servidor
    else if (error.response?.data?.error) {
      errorMessage = error.response.data.error
    }

    // SweetAlert de error
    await Swal.fire({
      icon: 'error',
      title: errorTitle,
      text: errorMessage,
      confirmButtonColor: '#7c3aed'
    })
  }
}

const agregarSeccionIndividual = async (seccionId) => {
  try {
    const seccion = secciones.value.find(s => s.seccionId === seccionId)

    // SIEMPRE agregar solo en memoria (tanto nuevo como edición)
    const catalogosDeSeccion = await obtenerCatalogosDeSeccion(seccionId)

    console.log('📦 Catálogos de sección obtenidos:', catalogosDeSeccion)

    // Crear un componente por cada catálogo
    // catalogosDeSeccion contiene objetos SeccionCatalogoNew con la relación 'catalogo'
    const componentes = catalogosDeSeccion.map(asignacion => ({
      catalogoId: asignacion.catalogoId,
      catalogo: asignacion.catalogo, // Esta es la relación cargada
      registroId: null,
      registro: null,
      costoCalculado: null
    }))

    // Crear objeto de sección local con sus componentes
    const seccionLocal = {
      seccion_id: seccionId,
      seccionId: seccionId,
      orden: seccionesLocales.value.length,
      seccion: seccion,
      componentes: componentes
    }

    seccionesLocales.value.push(seccionLocal)
    showSeccionModal.value = false
  } catch (error) {
    console.error('Error al agregar sección:', error)
  }
}

const getCatalogosCount = (seccionId) => {
  return catalogosPorSeccion.value[seccionId] || 0
}

const sincronizarSeccion = async (prototipoSeccionId) => {
  try {
    await sincronizarSeccionPrototipo(prototipoSeccionId)
    // Recargar el prototipo para ver los nuevos componentes
    await cargarPrototipo()
  } catch (error) {
    console.error('Error al sincronizar sección:', error)
  }
}

const actualizarComponente = async (seccionIndex, componenteIndex, registroId) => {
  try {
    // SIEMPRE actualizar solo en memoria (tanto nuevo como edición)
    const componente = seccionesLocales.value[seccionIndex].componentes[componenteIndex]
    componente.registroId = registroId ? parseInt(registroId) : null

    // Buscar el registro para mostrar sus valores usando catalogoId
    if (registroId && componente.catalogoId) {
      const regs = registrosPorCatalogo.value[componente.catalogoId]
      componente.registro = regs?.find(r => r.registroId === parseInt(registroId))

      // Calcular el costo del componente según tipoCalculo de los campos
      if (componente.registro && componente.registro.valores_campo) {
        let costoTotal = 0

        for (const valor of componente.registro.valores_campo) {
          // Solo procesar campos que son montos
          if (valor.campo?.esMonto && valor.valorNumerico) {
            let valorCalculado = parseFloat(valor.valorNumerico)

            // Si el campo es calculado, aplicar el tipo de cálculo
            if (valor.campo?.esCalculado && valor.campo?.tipoCalculo) {
              const areaPapel = parseFloat(areaPapelCalculada.value) || 0
              const areaCorrugado = parseFloat(areaCorrugadoCalculada.value) || 0
              const cantidadPaquete = parseFloat(formData.value.cantidadPorPaquete) || 1
              const paquetesTarima = parseFloat(formData.value.paquetesPorTarima) || 1

              switch (valor.campo.tipoCalculo) {
                case 'area_papel':
                  valorCalculado = valorCalculado * areaPapel
                  console.log(`💰 ${valor.campo.nombreCampo}: $${valor.valorNumerico} × ${areaPapel} m² (papel) = $${valorCalculado.toFixed(4)}`)
                  break
                case 'area_corrugado':
                  valorCalculado = valorCalculado * areaCorrugado
                  console.log(`💰 ${valor.campo.nombreCampo}: $${valor.valorNumerico} × ${areaCorrugado} m² (corrugado) = $${valorCalculado.toFixed(4)}`)
                  break
                case 'division_cantidad_paquete':
                  // Fórmula: COSTO / cantidadPorPaquete
                  valorCalculado = valorCalculado / cantidadPaquete
                  console.log(`💰 ${valor.campo.nombreCampo}: $${valor.valorNumerico} ÷ ${cantidadPaquete} (cant/paq) = $${valorCalculado.toFixed(4)}`)
                  break
                case 'division_cantidad_tarima':
                  // Fórmula: COSTO / (cantidadPorPaquete * paquetesPorTarima)
                  valorCalculado = valorCalculado / (cantidadPaquete * paquetesTarima)
                  console.log(`💰 ${valor.campo.nombreCampo}: $${valor.valorNumerico} ÷ (${cantidadPaquete} × ${paquetesTarima}) = $${valorCalculado.toFixed(4)}`)
                  break
                case 'division_envio':
                  // Fórmula: COSTO / (cantidadPorPaquete * paquetesPorTarima * TAR_X_UNIDAD)
                  // Buscar el valor de "Tar x Unidad" en los valores del mismo registro
                  const tarXUnidadValor = componente.registro.valores_campo.find(
                    v => v.campo?.nombreCampo === 'Tar x Unidad'
                  )
                  const tarXUnidad = tarXUnidadValor ? parseFloat(tarXUnidadValor.valorNumerico) || 1 : 1
                  valorCalculado = valorCalculado / (cantidadPaquete * paquetesTarima * tarXUnidad)
                  console.log(`💰 ${valor.campo.nombreCampo}: $${valor.valorNumerico} ÷ (${cantidadPaquete} × ${paquetesTarima} × ${tarXUnidad}) = $${valorCalculado.toFixed(4)}`)
                  break
                case 'valor_directo':
                default:
                  console.log(`💰 ${valor.campo.nombreCampo}: $${valorCalculado.toFixed(4)} (directo)`)
                  break
              }
            } else {
              console.log(`💰 ${valor.campo.nombreCampo}: $${valorCalculado.toFixed(4)} (no calculado)`)
            }

            costoTotal += valorCalculado
          }
        }

        componente.costoCalculado = costoTotal
        console.log(`✅ Costo total del componente ${componente.catalogo?.nombreCatalogo}: $${costoTotal.toFixed(4)}`)
      } else {
        componente.costoCalculado = 0
      }
    } else {
      componente.registro = null
      componente.costoCalculado = 0
    }
  } catch (error) {
    console.error('Error al actualizar componente:', error)
  }
}

const eliminarSeccion = async (seccionIndex) => {
  try {
    // SIEMPRE eliminar solo de memoria (tanto nuevo como edición)
    const seccion = seccionesLocales.value[seccionIndex]
    if (!confirm(`¿Eliminar la sección "${seccion.seccion?.nombreSeccion}" del prototipo?`)) return

    seccionesLocales.value.splice(seccionIndex, 1)
  } catch (error) {
    console.error('Error al eliminar sección:', error)
  }
}

const formatCurrency = (value) => {
  if (!value && value !== 0) return '0.00'
  return Number(value).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// Helper para mostrar el tipo de cálculo de forma amigable
const getTipoCalculoLabel = (tipoCalculo) => {
  const labels = {
    'valor_directo': 'Directo',
    'area_papel': 'Por área de papel',
    'area_corrugado': 'Por área de corrugado',
    'division_cantidad_paquete': 'División por cant/paquete',
    'division_cantidad_tarima': 'División por tarima',
    'division_envio': 'División por envío'
  }
  return labels[tipoCalculo] || tipoCalculo
}

// Helper para verificar si un componente tiene campos calculados
const hasCamposCalculados = (componente) => {
  if (!componente.registro?.valores_campo) return false
  return componente.registro.valores_campo.some(valor => valor.campo?.esCalculado)
}

// Watchers para recalcular costos cuando cambien cantidades de empaque o dimensiones
watch(() => formData.value.cantidadPorPaquete, () => {
  recalcularTodosLosCostos()
})

watch(() => formData.value.paquetesPorTarima, () => {
  recalcularTodosLosCostos()
})

// Watchers para dimensiones de papel
watch(() => formData.value.anchoPapel, () => {
  recalcularTodosLosCostos()
})

watch(() => formData.value.largoPapel, () => {
  recalcularTodosLosCostos()
})

// Watchers para dimensiones de corrugado
watch(() => formData.value.anchoCorrugado, () => {
  recalcularTodosLosCostos()
})

watch(() => formData.value.largoCorrugado, () => {
  recalcularTodosLosCostos()
})

// Función para recalcular todos los costos cuando cambien las cantidades o dimensiones
const recalcularTodosLosCostos = () => {
  seccionesLocales.value.forEach((seccion, seccionIndex) => {
    seccion.componentes?.forEach((componente, componenteIndex) => {
      if (componente.registroId) {
        actualizarComponente(seccionIndex, componenteIndex, componente.registroId)
      }
    })
  })
}
</script>
